<template>
  <div v-if="dadosProposta">
    <div v-if="novaInvoiceBP" class="bg-white">
      <!--  START HEADER INVOICE -->
      <div class="invoiceHeaderDiv pt-5 pr-5 pl-5 lg:pl-20 lg:pr-20">
        <div class="invoice-header flex justify-between items-center w-full">
          <div>
            <img src="../../assets/images/logo/bp-logo.png" width="150" />
          </div>
          <div class="div-button">
            <a target="_blank" :href="returnLinkWhatsVendedor()">
              <div id="botaoWppConsultor" class="flex gap-2">
                <img
                  src="../../assets/images/svg/iconWhatsapp.svg"
                  alt="Ícone Escudo"
                />
                <span style="font-size: 10px">WhatsApp do Consultor</span>
              </div>
            </a>
          </div>
        </div>
        <hr />
      </div>
      <!--  END HEADER INVOICE -->

      <div>
        <!--  START BLOCO INICIAL INVOICE -->
        <div class="bgAzulSuperiorLg pt-20">
          <div class="container pt-5">
            <div class="grupoCards">
              <div class="cardAzulPasso2 flex justify-between pt-5 pl-5 pb-5">
                <div>
                  <div class="tituloPrimeiroCardAzulPasso2 pb-3">
                    <span v-if="dadosProposta.dadosCliente.associado"
                      >Olá, {{ dadosProposta.dadosCliente.associado }} tudo bem?
                      &#128522;</span
                    >
                  </div>
                  <div class="subtituloCardPasso2 pb-5">
                    <span>Confira sua proposta abaixo!</span>
                  </div>
                  <vs-chip class="lg:hidden" color="#FFE9B0">
                    <div
                      class="flex justify-center items-center chipNumeroProposta gap-2"
                    >
                      <div>
                        <img
                          src="../../assets/images/svg/iconCopy.svg"
                          alt="ícone copy"
                          class="pt-1"
                        />
                      </div>
                      <div>
                        <span class="numeroProposta"
                          >N° {{ dadosProposta.idProposta }}</span
                        >
                      </div>
                    </div>
                  </vs-chip>
                </div>
                <div class="lg:hidden">
                  <img
                    src="../../assets/images/fotos-gustavo-lima/gustavo-lima-celular.png"
                    alt="Gustavo Lima segurando seu celular."
                    class="imgGustavoLimaCelular"
                    width="150px"
                  />
                </div>
                <div class="hidden lg:block lg:pr-20">
                  <img
                    src="../../assets/images/fotos-gustavo-lima/gustavo-lima-celular-lg.png"
                    alt="Gustavo Lima segurando seu celular."
                    class="imgGustavoLimaCelularLg"
                  />
                </div>
              </div>
              <div class="cardAzulPasso2Interno p-5 w-full lg:w-1/3 lg:mb-5">
                <div class="flex flex-col">
                  <div v-if="dadosProposta.exibirValoresVeiculoNaProposta">
                    <vs-chip color="#C3E1FF">
                      <span class="tituloCardAzulPasso2Interno"
                        >Avaliado em
                        {{
                          dadosProposta.dadosVeiculo.valorFipe | currency
                        }}</span
                      ></vs-chip
                    >
                  </div>
                  <div class="flex gap-2 pt-5">
                    <div>
                      <img
                        src="../../assets/images/svg/iconBlobCar.svg"
                        alt="Ícone carro."
                      />
                    </div>
                    <div>
                      <div class="descricaoVeiculoCardInterno">
                        <span
                          >{{ dadosProposta.dadosVeiculo.veiculoMarca }} -
                          {{ dadosProposta.dadosVeiculo.veiculoModelo }}
                          {{ dadosProposta.dadosVeiculo.anoFabricacao }}/{{
                            dadosProposta.dadosVeiculo.anoModelo
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  END BLOCO INICIAL INVOICE -->

        <div class="container">
          <div class="lg:flex lg:gap-5">
            <!--  START BLOCO PRODUTOS INCLUSOS INVOICE -->
            <div class="lg:w-2/3">
              <div class="tituloAzulPasso2 pt-5 pb-5">
                <span>O que está incluso?</span>
              </div>
              <div class="cardCinzaPasso2 p-5">
                <div
                  v-for="beneficio in beneficiosProdutosExibidos"
                  :key="beneficio.id"
                >
                  <div class="flex">
                    <div>
                      <img
                        src="../../assets/images/svg/iconCommentCheck.svg"
                        alt="Ícone comentário checked."
                        class="pr-3"
                      />
                    </div>
                    <div>
                      <span class="nomeBeneficiosCardCinza">{{
                        beneficio.nome || beneficio.nomeProduto
                      }}</span>
                      <div v-if="beneficio.descricao">
                        <span class="descricaoBeneficiosCardCinza">{{
                          beneficio.descricao
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <vs-divider />
                </div>
                <div class="lg:hidden">
                  <div
                    @click="alternaVisualizarProdutosInclusos()"
                    class="verMaisBeneficios flex items-center justify-center gap-2"
                  >
                    <span
                      >Ver
                      {{ verMaisBeneficiosInclusos ? 'menos' : 'mais' }}</span
                    >
                    <img
                      src="../../assets/images/svg/blueArrowDown.svg"
                      alt="Seta para baixo."
                      :class="{
                        iconeSetaParaCimaTransform: verMaisBeneficiosInclusos,
                        iconeSetaParaBaixoTransform: !verMaisBeneficiosInclusos,
                      }"
                      :style="{
                        transform: verMaisBeneficiosInclusos
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                      }"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!--  END BLOCO PRODUTOS INCLUSOS INVOICE -->

            <!--  START BLOCO DETALHES VALORES/VEÍCULO INVOICE -->
            <div class="lg:w-1/3">
              <div class="tituloAzulPasso2 pt-5">
                <span>Resumo</span>
              </div>
              <div class="CardBranco p-5 mt-5">
                <div class="flex justify-between items-center pb-5">
                  <div class="textoCardBranco">
                    <span>Número da proposta</span>
                  </div>
                  <vs-chip color="#FFE9B0">
                    <div
                      class="flex justify-center items-center chipNumeroProposta gap-2"
                    >
                      <div>
                        <img
                          src="../../assets/images/svg/iconCopy.svg"
                          alt="ícone copy"
                          class="pt-1"
                        />
                      </div>
                      <div>
                        <span class="numeroProposta"
                          >N° {{ dadosProposta.idProposta }}</span
                        >
                      </div>
                    </div>
                  </vs-chip>
                </div>
                <div class="flex justify-between items-center pt-5">
                  <div class="textoCardBranco">
                    <span>Mensalidade</span>
                  </div>
                  <div>
                    <span class="simboloReal">R$</span
                    ><span class="valoresCotacao">{{
                      somaValorTotalMes(produtosObrigatorios, produtosOpcionais)
                    }}</span>
                  </div>
                </div>
                <vs-divider />
                <div>
                  <div class="flex justify-between items-center pt-5">
                    <div>
                      <div class="textoCardBranco">
                        <span>Primeira parcela</span>
                      </div>
                      <div class="textoSubtituloCardBranco">
                        <!-- <span>Taxa administrativa</span> -->
                      </div>
                    </div>
                    <div>
                      <span class="simboloReal">R$</span
                      ><span class="valoresCotacao">{{
                        converteValorParaMoeda(
                          this.somaValorTotalValoresAvista(
                            this.produtosObrigatorios,
                            this.produtosOpcionais,
                          ),
                        )
                      }}</span>
                    </div>
                  </div>
                </div>
                <vs-divider />
                <div>
                  <div class="flex gap-2 items-center">
                    <div class="flex items-center">
                      <img
                        src="../../assets/images/svg/iconBlobCar.svg"
                        iconCarCrash
                        alt="Ícone carro."
                      />
                    </div>
                    <div class="flex flex-col justify-center">
                      <div class="textoSubtituloCardBranco">
                        <span>Placa</span>
                      </div>
                      <div class="placaVcl">
                        <span>{{ dadosProposta.dadosVeiculo.placa }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <vs-divider />
                <div>
                  <div class="flex gap-2 items-center">
                    <div class="flex items-center">
                      <img
                        src="../../assets/images/svg/iconCarCrash.svg"
                        alt="Ícone carro batido."
                      />
                    </div>
                    <div class="flex flex-col justify-center">
                      <div class="textoSubtituloCardBranco">
                        <span>Franquia:</span>
                      </div>
                      <div class="placaVcl">
                        <span
                          >{{ dadosProposta.valorCotaParticipacao }}% FIPE,
                          mínimo de
                          {{
                            dadosProposta.valorParticipacaoMinimo | currency
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cardVerde p-5 mt-5">
                  <div class="flex justify-center items-center gap-4">
                    <div>
                      <img
                        src="../../assets/images/svg/iconParty.svg"
                        alt="Ícone comemoração."
                      />
                    </div>
                    <div class="placaVcl">
                      <span
                        >Faça a contratação online e aproveite um processo
                        simples, seguro e rápido</span
                      >
                    </div>
                  </div>
                  <div
                    class="botaoContratarOnline p-5 flex justify-center mt-5"
                    @click="queroContratarOnline()"
                  >
                    <span>QUERO CONTRATAR ONLINE</span>
                  </div>
                </div>
                <a target="_blank" :href="returnLinkWhatsVendedor()">
                  <div
                    class="botaoPrecisoDeAjudaConsultor p-5 flex justify-center mt-5 gap-2 items-center"
                  >
                    <div class="flex items-center">
                      <img
                        src="../../assets/images/svg/iconWhatsappGray.svg"
                        alt="WhatsApp ícone."
                      />
                    </div>
                    <div>
                      <span>Preciso da ajuda de um consultor.</span>
                    </div>
                  </div>
                </a>
                <vs-divider />
                <div class="flex justify-center textoCardBranco pb-5">
                  <span>Você tem um cupom de desconto?</span>
                </div>
                <div>
                  <vs-alert
                    v-if="dadosProposta.cupom"
                    color="success"
                    active="true"
                    class="mt-1 mb-3"
                    style="height: auto !important"
                  >
                    O cupom {{ dadosProposta.cupom }} foi aplicado!
                  </vs-alert>
                  <div class="mb-4 divCupom">
                    <vs-input
                      class="inputCupom w-full pr-5 pl-5 pt-4 pb-3 text-grey"
                      id="cupom"
                      placeholder="Digite aqui o cupom"
                      :danger="dangerCupomDesconto"
                      size="default"
                      @keyup="mascaraCupom($event)"
                      danger-text="Informe o cupom"
                      autocomplete="off"
                      v-model="cupomDesconto"
                    />
                    <!-- <input
                      class="inputCupom shadow appearance-none border rounded w-full pr-5 pl-5 pt-4 pb-3 text-grey leading-tight focus:outline-none focus:shadow-outline"
                      id="cupom"
                      type="text"
                      placeholder="Digite aqui o cupom"
                      danger="dangerCupomDesconto"
                    /> -->
                    <vs-button
                      color="black"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-check"
                      size="default"
                      class="cupomButton"
                      id="cupomButton"
                      @click="aplicaDesconto()"
                    ></vs-button>
                  </div>
                </div>
                <div class="placaVcl text-center p-5">
                  <span>Enviar proposta</span>
                </div>
                <div class="flex justify-around pl-5 pr-5">
                  <vx-tooltip
                    active="false"
                    text="Fazer Download"
                    onclick="window.print()"
                  >
                    <div class="cursor-pointer">
                      <img
                        src="../../assets/images/svg/iconDownloadPDF.svg"
                        alt="ícone Download PDF."
                      />
                    </div>
                  </vx-tooltip>
                  <div>
                    <a target="_blank" :href="returnLinkWhatsVendedor()">
                      <vx-tooltip text="Enviar por WhatsApp">
                        <div>
                          <img
                            src="../../assets/images/svg/iconBlobWhatsapp.svg"
                            alt="ícone whatsapp."
                          />
                        </div>
                      </vx-tooltip>
                    </a>
                  </div>
                  <vx-tooltip text="Copiar Link" class="cursor-pointer">
                    <div
                      @click="copiarText()"
                      value="click to copy"
                      class="flex p-1 justify-center"
                    >
                      <img
                        src="../../assets/images/svg/iconBlobCopy.svg"
                        alt="ícone copiar link."
                      />
                    </div>
                  </vx-tooltip>
                </div>
              </div>
            </div>
            <!--  END BLOCO DETALHES VALORES/VEÍCULO INVOICE -->
          </div>
        </div>

        <vs-divider />
        <div class="text-center">
          <div>
            <img src="../../assets/images/logo/bp-logo.png" width="150" />
          </div>
          <div class="textFooter pb-5">
            <span>2023 - Bem Protege - Todos os direitos reservados</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!retornoRegistroFinanceiro && formularioConfirmacaoDados"
      class="cadastroDeDadosPg bg-white flex flex-col"
    >
      <!--  START HEADER FOMULÁRIOS -->
      <div class="flex-grow">
        <div class="invoiceHeaderDiv pt-5 pr-5 pl-5 lg:pl-20 lg:pr-20">
          <div class="invoice-header flex justify-between items-center w-full">
            <div>
              <img src="../../assets/images/logo/bp-logo.png" width="150" />
            </div>
            <div class="div-button">
              <div class="flex gap-2 textoAmbienteSeguro items-center">
                <img
                  src="../../assets/images/svg/iconLock.svg"
                  alt="Ícone Cadeado."
                />
                <span>Ambiente Seguro</span>
              </div>
            </div>
          </div>
          <hr />
        </div>
        <!--  END HEADER FOMULÁRIOS -->
        <div class="pt-20 pb-5 mb-5 w-full lg:mb-0 lg:pl-20 lg:pr-20">
          <div
            class="cardsCinzaOpcoesBlock pl-5 pr-5 pt-10 lg:flex lg:w-full lg:justify-between lg:gap-5"
          >
            <div class="lg:w-1/4">
              <div class="resumoValoresFundoAzul w-full hidden lg:block">
                <div class="flex justify-between p-5">
                  <!-- Mensalidade -->
                  <div>
                    <div class="tituloValores">
                      <span>Mensalidade</span>
                    </div>
                    <div v-if="!isRecalculating">
                      <span class="sifraoValores">R$</span>
                      <span class="valoresFixadosFooter">
                        {{
                          this.converteValorParaMoeda(valorMensalidadeDiferenca)
                        }}
                      </span>
                    </div>
                    <div v-else>
                      <span class="valoresFixadosFooter"> ... </span>
                    </div>
                  </div>

                  <!-- Taxa Administrativa -->
                  <div>
                    <div class="tituloValores">
                      <span>Taxa administrativa</span>
                    </div>
                    <div v-if="!isRecalculating">
                      <span class="sifraoValores">R$</span>
                      <span class="valoresFixadosFooter">
                        {{
                          converteValorParaMoeda(
                            this.somaValorTotalValoresAvista(
                              this.produtosObrigatorios,
                              this.produtosOpcionais,
                            ),
                          )
                        }}
                      </span>
                    </div>
                    <div v-else>
                      <span class="valoresFixadosFooter"> ... </span>
                    </div>
                  </div>
                </div>
                <div class="cardCinzaOpcoes p-5 mb-5">
                  <div class="flex items-center justify-between lg:w-full">
                    <div>
                      <div class="tituloCardCinzaOpcoes">
                        <span>Coberturas opcionais</span>
                      </div>
                      <div class="subtituloCardCinzaOpcoes">
                        <span>Acrescente coberturas opcionais</span>
                      </div>
                    </div>
                    <div>
                      <img
                        src="../../assets/images/svg/iconArrowDownBlue.svg"
                        alt="Ícone seta para baixo."
                      />
                    </div>
                  </div>
                  <transition name="slide">
                    <div class="pt-5">
                      <div
                        v-for="produto in produtosOpcionais"
                        :key="produto.id"
                        v-if="produto.exibir == true"
                      >
                        <div class="pb-2 pt-2 flex justify-between w-full">
                          <div class="flex justify-start items-start">
                            <vs-checkbox
                              v-model="produto.selecionado"
                              @input="
                                selecionaProduto(produto, produto.selecionado)
                              "
                            >
                            </vs-checkbox>
                            <div>
                              <span
                                class="produtosOpcionaisNome flex items-start"
                                >{{ produto.nomeProduto }}</span
                              >
                            </div>
                          </div>
                          <div class="flex justify-end">
                            <span class="produtosOpcionaisSifra mr-1">R$</span
                            ><span class="produtosOpcionaisValor">{{
                              converteValorParaMoeda(produto.valor)
                            }}</span>
                          </div>
                        </div>
                        <div
                          v-if="produto.descricao"
                          class="produtosOpcionaisDescricao pl-5 ml-5 w-2/3"
                        >
                          <span>{{ produto.descricao }}</span>
                        </div>
                        <hr class="divisorProdutosOpcionais mb-2" />
                      </div>
                      <div v-if="verProdutosOpcionais">
                        <div
                          class="botaoProximaEtapa p-4 mt-5 mb-5 flex justify-center gap-2"
                          @click="proximaEtapaProdutosOpcionais"
                        >
                          <span>Próxima etapa</span>
                          <img
                            src="../../assets/images/svg/iconArrowRight.svg"
                            alt="Ícone seta para a direita."
                          />
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
              <div class="cardCinzaOpcoes p-5 mb-5 lg:hidden">
                <div class="flex items-center justify-between lg:w-full">
                  <div>
                    <div class="tituloCardCinzaOpcoes">
                      <span>Coberturas opcionais</span>
                    </div>
                    <div class="subtituloCardCinzaOpcoes">
                      <span>Acrescente coberturas opcionais</span>
                    </div>
                  </div>
                  <div>
                    <img
                      src="../../assets/images/svg/iconArrowDownBlue.svg"
                      alt="Ícone seta para baixo."
                    />
                  </div>
                </div>
                <transition name="slide">
                  <div class="pt-5">
                    <div
                      v-for="produto in produtosOpcionais"
                      :key="produto.id"
                      v-if="produto.exibir == true"
                    >
                      <div class="pb-2 pt-2 flex justify-between w-full">
                        <div class="flex justify-start items-start">
                          <vs-checkbox
                            v-model="produto.selecionado"
                            @input="
                              selecionaProduto(produto, produto.selecionado)
                            "
                          >
                          </vs-checkbox>
                          <div>
                            <span
                              class="produtosOpcionaisNome flex items-start"
                              >{{ produto.nomeProduto }}</span
                            >
                          </div>
                        </div>
                        <div class="flex justify-end">
                          <span class="produtosOpcionaisSifra mr-1">R$</span
                          ><span class="produtosOpcionaisValor">{{
                            converteValorParaMoeda(produto.valor)
                          }}</span>
                        </div>
                      </div>
                      <div
                        v-if="produto.descricao"
                        class="produtosOpcionaisDescricao pl-5 ml-5 w-2/3"
                      >
                        <span>{{ produto.descricao }}</span>
                      </div>
                      <hr class="divisorProdutosOpcionais mb-2" />
                    </div>
                    <div v-if="verProdutosOpcionais">
                      <div
                        class="botaoProximaEtapa p-4 mt-5 mb-5 flex justify-center gap-2"
                        @click="
                          proximaEtapaProdutosOpcionais(),
                            scrollBloco('divCadastro')
                        "
                      >
                        <span>Próxima etapa</span>
                        <img
                          src="../../assets/images/svg/iconArrowRight.svg"
                          alt="Ícone seta para a direita."
                        />
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div class="lg:w-1/4" ref="divCadastro">
              <div class="cardCinzaOpcoes p-5 mb-5">
                <div class="flex items-center justify-between lg:w-full">
                  <div>
                    <div class="tituloCardCinzaOpcoes">
                      <span>Cadastro</span>
                    </div>
                    <div class="subtituloCardCinzaOpcoes">
                      <span>Insira os seus dados</span>
                    </div>
                  </div>
                  <div>
                    <transition name="slide">
                      <img
                        v-if="!iconCheckCadastro"
                        src="../../assets/images/svg/iconArrowDownBlue.svg"
                        alt="Ícone seta para baixo."
                        :class="{
                          iconeSetaParaCimaTransform:
                            !rotacionaIconSetaProdutosOpcionais,
                          iconeSetaParaBaixoTransform:
                            rotacionaIconSetaProdutosOpcionais,
                        }"
                        :style="{
                          transform: rotacionaIconSetaCadastroDadosPessoais
                            ? 'rotate(180deg)'
                            : 'rotate(0deg)',
                        }"
                      />
                      <img
                        v-if="iconCheckCadastro"
                        src="../../assets/images/svg/iconCheckCircle.svg"
                        alt="Ícone checked."
                      />
                    </transition>
                  </div>
                </div>
                <transition name="slide">
                  <div v-show="verDadosPessoais">
                    <form role="form" @submit.stop.prevent>
                      <div>
                        <div>
                          <ul class="flex justify-between pt-5 centerx gap-2">
                            <li
                              v-for="tipoPessoaOpcao in tiposPessoa"
                              :key="tipoPessoaOpcao.id"
                              :class="{
                                backGroundToggleTipoPessoaSelecionada:
                                  formDadosPessoais.tipoPessoa ===
                                  tipoPessoaOpcao.tipoPessoa,
                                backGroundToggleTipoPessoaNaoSelecionada:
                                  formDadosPessoais.tipoPessoa !==
                                  tipoPessoaOpcao.tipoPessoa,
                              }"
                            >
                              <vs-radio
                                v-model="formDadosPessoais.tipoPessoa"
                                :vs-value="tipoPessoaOpcao.tipoPessoa"
                              >
                                {{ tipoPessoaOpcao.tipoPessoa }}
                              </vs-radio>
                            </li>
                          </ul>
                        </div>
                        <div
                          v-if="formDadosPessoais.tipoPessoa == 'Pessoa Física'"
                          class="pt-5"
                        >
                          <div class="mb-2">
                            <label for="cpfCnpjInput" class="labelInputsInvoice"
                              >CPF</label
                            >
                          </div>
                          <vs-input
                            v-model="formDadosPessoais.cpfcnpj"
                            danger-text="CPF inválido"
                            class="w-full"
                            size="large"
                            id="cpfCnpjInput"
                            name="cpfCnpjInput"
                            v-mask="'###.###.###-##'"
                            :state="validateState('cpfCnpjInput')"
                            :danger="validateClass('cpfCnpjInput')"
                            v-validate="{ required: true, min: 14, max: 14 }"
                            @keyup.native="keymonitorCpfCnpj"
                            :disabled="!isCpfCanChange()"
                            autocomplete="off"
                            aria-autocomplete="none"
                            role="presentation"
                          />
                        </div>
                        <div
                          v-if="
                            formDadosPessoais.tipoPessoa == 'Pessoa Jurídica'
                          "
                          class="pt-5"
                        >
                          <div class="mb-2">
                            <label for="cpfCnpjInput" class="labelInputsInvoice"
                              >CNPJ</label
                            >
                          </div>
                          <vs-input
                            v-model="formDadosPessoais.cpfcnpj"
                            danger-text="CNPJ inválido"
                            class="w-full"
                            size="large"
                            id="cpfCnpjInput"
                            name="cpfCnpjInput"
                            v-mask="'##.###.###/####-##'"
                            :state="validateState('cpfCnpjInput')"
                            :danger="validateClass('cpfCnpjInput')"
                            v-validate="{ required: true, min: 18, max: 18 }"
                            :disabled="!isCpfCanChange()"
                            autocomplete="off"
                            aria-autocomplete="none"
                            role="presentation"
                          />
                        </div>
                        <div class="pt-5">
                          <div class="mb-2">
                            <label
                              for="nomeCompletoInput"
                              class="labelInputsInvoice"
                              >{{
                                formDadosPessoais.tipoPessoa == 'Pessoa Física'
                                  ? 'Nome Completo'
                                  : 'Razão Social'
                              }}</label
                            >
                          </div>
                          <vs-input
                            danger-text="Campo obrigatório"
                            val-icon-danger="clear"
                            v-model="formDadosPessoais.nome"
                            class="w-full"
                            size="large"
                            id="nomeCompletoInput"
                            name="nomeCompletoInput"
                            :state="validateState('nomeCompletoInput')"
                            :danger="validateClass('nomeCompletoInput')"
                            v-validate="{ required: true }"
                          />
                        </div>
                        <div class="pt-5">
                          <div class="mb-2">
                            <label for="emailInput" class="labelInputsInvoice"
                              >E-mail</label
                            >
                          </div>
                          <vs-input
                            danger-text="Campo obrigatório"
                            val-icon-danger="clear"
                            v-model="formDadosPessoais.email"
                            class="w-full"
                            size="large"
                            id="emailInput"
                            name="emailInput"
                            :state="validateState('emailInput')"
                            :danger="validateClass('emailInput')"
                            v-validate="{ required: true }"
                          />
                        </div>
                        <div class="pt-5">
                          <div class="mb-2">
                            <label for="celularInput" class="labelInputsInvoice"
                              >Celular</label
                            >
                          </div>
                          <vs-input
                            v-model="formDadosPessoais.celular"
                            danger-text="Campo obrigatório"
                            class="w-full"
                            size="large"
                            v-mask="'(##) #####-####'"
                            id="celularInput"
                            name="celularInput"
                            :state="validateState('celularInput')"
                            :danger="validateClass('celularInput')"
                            v-validate="{ required: true, min: 15 }"
                          />
                        </div>
                        <div class="pt-5">
                          <div class="mb-4">
                            <label class="labelInputsInvoice"
                              >Receber notificações por:</label
                            >
                          </div>
                          <div class="flex justify-between">
                            <vs-checkbox
                              v-model="formDadosPessoais.canaisComunicacao"
                              :vs-value="'WhatsApp'"
                              >WhatsApp</vs-checkbox
                            >
                            <vs-checkbox
                              v-model="formDadosPessoais.canaisComunicacao"
                              :vs-value="'Email'"
                              >E-mail</vs-checkbox
                            >
                            <vs-checkbox
                              v-model="formDadosPessoais.canaisComunicacao"
                              :vs-value="'SMS'"
                              >SMS</vs-checkbox
                            >
                          </div>
                        </div>
                      </div>

                      <div
                        class="botaoProximaEtapa p-4 mt-5 mb-5 flex justify-center gap-2"
                        @click="proximaEtapaCadastroDadosPessoais"
                      >
                        <span>Próxima etapa</span>
                        <img
                          src="../../assets/images/svg/iconArrowRight.svg"
                          alt="Ícone seta para a direita."
                        />
                      </div>
                    </form>
                  </div>
                </transition>
              </div>
            </div>
            <div class="lg:w-1/4">
              <div class="cardCinzaOpcoes p-5 mb-5 pb-16">
                <div class="flex items-center justify-between">
                  <div>
                    <div class="tituloCardCinzaOpcoes">
                      <span>Endereço</span>
                    </div>
                    <div class="subtituloCardCinzaOpcoes">
                      <span>Informe o seu endereço</span>
                    </div>
                  </div>
                  <div>
                    <img
                      v-if="!iconCheckEndereco"
                      src="../../assets/images/svg/iconArrowDownBlue.svg"
                      alt="Ícone seta para baixo."
                      :class="{
                        iconeSetaParaCimaTransform:
                          rotacionaIconSetaProdutosOpcionais,
                        iconeSetaParaBaixoTransform:
                          !rotacionaIconSetaProdutosOpcionais,
                      }"
                      :style="{
                        transform: rotacionaIconSetaDadosEndereco
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                      }"
                    />
                    <img
                      v-if="iconCheckEndereco"
                      src="../../assets/images/svg/iconCheckCircle.svg"
                      alt="Ícone checked."
                    />
                  </div>
                </div>
                <transition name="slide">
                  <div v-show="verDadosEndereco">
                    <form role="form" @submit.stop.prevent>
                      <div>
                        <div class="pt-5">
                          <div class="mb-2">
                            <label for="CEP" class="labelInputsInvoice"
                              >CEP</label
                            >
                          </div>
                          <vs-input
                            v-model="formDadosPessoais.cep"
                            class="w-full"
                            size="large"
                            v-mask="'##.###-###'"
                            @keyup.native="keyMonitorCEP"
                            id="CEP"
                            name="CEP"
                            danger-text="CEP inválido"
                            :state="validateState('CEP')"
                            :danger="validateClass('CEP')"
                            v-validate="{ required: true }"
                          />
                        </div>
                        <div class="pt-5">
                          <div class="mb-2">
                            <label for="Endereco" class="labelInputsInvoice"
                              >Endereço</label
                            >
                          </div>
                          <vs-input
                            v-model="formDadosPessoais.endereco"
                            danger-text="Campo obrigatório."
                            class="w-full"
                            size="large"
                            id="Endereco"
                            name="Endereco"
                            :state="validateState('Endereco')"
                            :danger="validateClass('Endereco')"
                            v-validate="{ required: true }"
                          />
                        </div>
                        <div class="flex gap-5">
                          <div class="pt-5 w-1/2">
                            <div class="mb-2">
                              <label for="numero" class="labelInputsInvoice"
                                >Número</label
                              >
                            </div>
                            <vs-input
                              v-model="formDadosPessoais.numero"
                              danger-text="Campo obrigatório."
                              class="w-full"
                              size="large"
                              id="numero"
                              name="numero"
                              :state="validateState('numero')"
                              :danger="validateClass('numero')"
                              v-validate="{ required: true }"
                            />
                          </div>
                          <div class="pt-5 w-1/2">
                            <div class="mb-2">
                              <label
                                for="complemento"
                                class="labelInputsInvoice"
                                >Complemento</label
                              >
                            </div>
                            <vs-input
                              v-model="formDadosPessoais.complemento"
                              class="w-full"
                              size="large"
                              id="complemento"
                            />
                          </div>
                        </div>
                        <div class="pt-5">
                          <div class="mb-2">
                            <label for="Bairro" class="labelInputsInvoice"
                              >Bairro</label
                            >
                          </div>
                          <vs-input
                            v-model="formDadosPessoais.bairro"
                            danger-text="Campo obrigatório."
                            class="w-full"
                            size="large"
                            id="Bairro"
                            name="Bairro"
                            :state="validateState('Bairro')"
                            :danger="validateClass('Bairro')"
                            v-validate="{ required: true }"
                          />
                        </div>

                        <!-- Estado -->
                        <div class="pt-5">
                          <div class="mb-2">
                            <label for="estado" class="labelInputsInvoice">
                              Estado
                            </label>
                          </div>
                          <v-select
                            :options="listEstados"
                            v-model="formDadosPessoais.estado"
                            name="estado"
                            id="estado"
                            class="vs-select"
                            v-validate="{ required: true }"
                            :class="{ 'error-select': validateClass('estado') }"
                            @input="clearCidade"
                          >
                          </v-select>
                          <span
                            class="error-select-text"
                            v-if="validateClass('estado')"
                          >
                            Campo obrigatório.
                          </span>
                        </div>

                        <!-- Cidade -->
                        <div class="pt-5">
                          <div class="mb-2">
                            <label for="cidade" class="labelInputsInvoice">
                              Cidade
                            </label>
                          </div>
                          <v-select
                            :options="listCidade"
                            v-model="formDadosPessoais.cidade"
                            class="vs-select"
                            :class="{ 'error-select': validateClass('cidade') }"
                            id="cidade"
                            name="cidade"
                            :reduce="(item) => item.label"
                            v-validate="{ required: true }"
                          >
                          </v-select>
                          <span
                            class="error-select-text"
                            v-if="validateClass('cidade')"
                          >
                            Campo obrigatório.
                          </span>
                        </div>

                        <div
                          class="botaoProximaEtapa p-4 mt-5 mb-5 flex justify-center gap-2"
                          @click="atualizaDadosPropostaAceita"
                        >
                          <span>Próxima etapa</span>
                          <img
                            src="../../assets/images/svg/iconArrowRight.svg"
                            alt="Ícone seta para a direita."
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </transition>
              </div>
            </div>
            <div class="lg:w-1/4">
              <div class="cardCinzaOpcoes pt-5 pl-1 pr-1 pb-1 mb-5">
                <div class="flex items-center justify-between pr-5 pl-5 pb-4">
                  <div>
                    <div class="tituloCardCinzaOpcoes">
                      <span>Pagamento</span>
                    </div>
                    <div class="subtituloCardCinzaOpcoes">
                      <span>Dados e resumo para pagamento</span>
                    </div>
                  </div>
                  <div>
                    <img
                      src="../../assets/images/svg/iconArrowDownBlue.svg"
                      alt="Ícone seta para baixo."
                      :class="{
                        iconeSetaParaCimaTransform:
                          rotacionaIconSetaProdutosOpcionais,
                        iconeSetaParaBaixoTransform:
                          !rotacionaIconSetaProdutosOpcionais,
                      }"
                      :style="{
                        transform: rotacionaIconSetaDadosPagamento
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                      }"
                    />
                  </div>
                </div>
                <transition name="slide">
                  <div v-show="verDadosFinanceiros">
                    <div class="cardDadosPagamentos p-5 mt-5">
                      <div class="flex justify-between">
                        <div class="textoCardBranco">
                          <span>Número da proposta</span>
                        </div>
                        <div>
                          <vs-chip color="#FFE9B0">
                            <div>
                              <img
                                src="../../assets/images/svg/iconCopy.svg"
                                alt="ícone copy"
                                class="pt-1"
                              />
                            </div>
                            <div>
                              <span class="numeroProposta"
                                >N° {{ dadosProposta.idProposta }}</span
                              >
                            </div>
                          </vs-chip>
                        </div>
                      </div>
                      <div>
                        <div class="flex justify-between items-center pt-5">
                          <div>
                            <div class="textoCardBranco">
                              <span>Primeira parcela</span>
                            </div>
                            <div class="textoSubtituloCardBranco">
                              <span>Taxa administrativa</span>
                            </div>
                          </div>
                          <div>
                            <span class="simboloReal mr-1">R$</span
                            ><span class="valoresCotacao">{{
                              converteValorParaMoeda(
                                this.somaValorTotalValoresAvista(
                                  this.produtosObrigatorios,
                                  this.produtosOpcionais,
                                ),
                              )
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <vs-divider />
                      <div class="flex justify-between items-center">
                        <div class="textoMensalidade">
                          <span>Mensalidade</span>
                        </div>
                        <div class="flex items-center gap-1">
                          <span class="simboloRealPagamento">R$</span
                          ><span class="valoresCotacaoPagamento">{{
                            this.converteValorParaMoeda(
                              valorMensalidadeDiferenca,
                            )
                          }}</span>
                        </div>
                      </div>

                      <vs-divider />

                      <!-- <div class="cardAzul p-5 mb-5">
                        <div
                          @click="alternaVisualizarCartao"
                          class="flex gap-2 items-center cursor-pointer"
                        >
                          <div>
                            <img
                              src="../../assets/images/svg/iconCreditCardBlueBlob.svg"
                              alt="Ícone Cartão de crédito."
                            />
                          </div>
                          <div><span>Pagar com Cartão de Crédito</span></div>
                        </div>
                        <transition name="slide">
                          <form role="form" @submit.stop.prevent>
                            <div v-show="verDadosCartaoDeCredito">
                              <div class="pt-5">
                                <div class="mb-2">
                                  <label
                                    for="nomeCompleto"
                                    class="labelInputsInvoice"
                                    >Nome Completo</label
                                  >
                                </div>
                                <vs-input
                                  danger-text="Campo obrigatório."
                                  val-icon-danger="clear"
                                  v-model="cartaoDeCredito.name"
                                  class="w-full"
                                  size="large"
                                  id="nomeCompleto"
                                  name="nomeCompleto"
                                  :state="validateState('nomeCompleto')"
                                  :danger="validateClass('nomeCompleto')"
                                  v-validate="{ required: true }"
                                />
                              </div>
                              <div class="pt-5">
                                <div class="mb-2">
                                  <label
                                    for="NumeroDoCartao"
                                    class="labelInputsInvoice"
                                    >Número do cartão</label
                                  >
                                </div>
                                <vs-input
                                  danger-text="Campo obrigatório."
                                  val-icon-danger="clear"
                                  v-model="cartaoDeCredito.cardNumber"
                                  class="w-full"
                                  v-mask="'#### #### #### ####'"
                                  size="large"
                                  id="NumeroDoCartao"
                                  name="NumeroDoCartao"
                                  :state="validateState('NumeroDoCartao')"
                                  :danger="validateClass('NumeroDoCartao')"
                                  v-validate="{ required: true }"
                                />
                              </div>
                              <div class="flex gap-1">
                                <div class="pt-5 w-1/2">
                                  <div class="mb-2">
                                    <label
                                      for="ExpiracaoCartao"
                                      class="labelInputsInvoice"
                                      >Expiração (mm/aa)</label
                                    >
                                  </div>
                                  <vs-input
                                    danger-text="Campo obrigatório."
                                    val-icon-danger="clear"
                                    v-model="cartaoDeCredito.expiration"
                                    class="w-full"
                                    size="large"
                                    id="ExpiracaoCartao"
                                    name="ExpiracaoCartao"
                                    v-mask="'##/##'"
                                    :state="validateState('ExpiracaoCartao')"
                                    :danger="validateClass('ExpiracaoCartao')"
                                    v-validate="{ required: true }"
                                  />
                                </div>
                                <div class="pt-5 w-1/2">
                                  <div class="mb-2 pl-2">
                                    <label
                                      for="cvvCartao"
                                      class="labelInputsInvoice"
                                      >CVV</label
                                    >
                                  </div>
                                  <vs-input
                                    danger-text="Campo obrigatório."
                                    val-icon-danger="clear"
                                    v-model="cartaoDeCredito.security"
                                    class="w-full"
                                    size="large"
                                    id="cvvCartao"
                                    name="cvvCartao"
                                    v-mask="'###'"
                                    :state="validateState('cvvCartao')"
                                    :danger="validateClass('cvvCartao')"
                                    v-validate="{ required: true }"
                                  />
                                </div>
                              </div>
                              <div
                                @click="
                                  (formaPagamentoSelecionada =
                                    'Cartão de Crédito'),
                                    pagarComCartaoCredito()
                                "
                                class="text-center pt-5"
                              >
                                <div
                                  class="buttonConfirmarPg flex gap-2 items-center justify-center"
                                >
                                  <span>Confirmar meu Pagamento</span>
                                  <img
                                    src="../../assets/images/svg/iconArrowRight.svg"
                                    alt="Ícone seta para a direita."
                                  />
                                </div>
                              </div>
                            </div>
                          </form>
                        </transition>
                      </div>

                      <div class="cardAzul p-5 mb-5">
                        <div
                          @click="alternaVisualizarPix"
                          class="flex gap-2 items-center cursor-pointer"
                        >
                          <div>
                            <img
                              src="../../assets/images/svg/iconPix.svg"
                              alt="Ícone PIX."
                            />
                          </div>
                          <div><span>Pagar com PIX</span></div>
                        </div>
                        <transition name="slide">
                          <div v-show="verDadosPix">
                            <div class="text-center pt-5">
                              <div
                                class="buttonConfirmarPg flex gap-2 items-center justify-center"
                                @click="
                                  (formaPagamentoSelecionada = 'Pix'),
                                    confirmaPagamento()
                                "
                              >
                                <span>Confirmar meu Pagamento</span>
                                <img
                                  src="../../assets/images/svg/iconArrowRight.svg"
                                  alt="Ícone seta para a direita."
                                />
                              </div>
                            </div>
                          </div>
                        </transition>
                      </div>

                      <div class="cardAzul p-5 mb-5">
                        <div
                          @click="alternaVisualizarDadosFGTS"
                          class="flex gap-2 items-center cursor-pointer"
                        >
                          <div>
                            <img
                              src="../../assets/images/svg/iconFGTS.svg"
                              alt="Ícone FGTS."
                            />
                          </div>
                          <div><span>Pagar com FGTS</span></div>
                        </div>
                        <transition name="slide">
                          <div v-show="verDadosFGTS">
                            <div class="textoFGTS">
                              <p>
                                Você já sabe: quando se trata de proteção, a Bem
                                Protege é a melhor opção!
                              </p>
                              <p>
                                Pague sua adesão sem tirar o dinheiro do bolso,
                                só aqui na <b>BEM PROTEGE</b>. Entre em contato
                                com seu consultor e saiba mais.
                              </p>
                            </div>
                            <div class="text-center pt-5">
                              <a
                                target="_blank"
                                :href="returnLinkWhatsVendedor()"
                              >
                                <div
                                  class="buttonConfirmarPg flex gap-2 items-center justify-center"
                                >
                                  <span>WhatsApp do Consultor</span>
                                  <img
                                    src="../../assets/images/svg/iconWhatsapp.svg"
                                    alt="Ícone seta para a direita."
                                  />
                                </div>
                              </a>
                            </div>
                          </div>
                        </transition>
                      </div> -->

                      <div>
                        <div
                          @click="alternaVisualizarPgBoleto"
                          class="textoPgBoleto pb-5 cursor-pointer"
                        >
                          <span>Pagar com Boleto Bancário</span>
                        </div>
                        <transition name="slide">
                          <div class="pb-5">
                            <div class="cardAzul p-5 mb-5">
                              <div class="flex gap-2 items-center">
                                <div>
                                  <img
                                    src="../../assets/images/svg/iconBarCode.svg"
                                    alt="Ícone código de barras."
                                  />
                                </div>
                                <div>
                                  <span>Pagar com Boleto Bancário</span>
                                </div>
                              </div>
                              <transition name="slide">
                                <div>
                                  <div class="text-center pt-5">
                                    <div
                                      class="buttonConfirmarPg flex gap-2 items-center justify-center"
                                      @click="
                                        (formaPagamentoSelecionada = 'Boleto'),
                                          confirmaPagamento()
                                      "
                                    >
                                      <span>Confirmar meu Pagamento</span>
                                      <img
                                        src="../../assets/images/svg/iconArrowRight.svg"
                                        alt="Ícone seta para a direita."
                                      />
                                    </div>
                                  </div>
                                </div>
                              </transition>
                            </div>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div class="w-full footerAzul">
            <div class="w-full p-3 lg:hidden">
              <div class="flex justify-around">
                <div class="text-right">
                  <div class="tituloValores">
                    <span>Mensalidade </span>
                  </div>
                  <div>
                    <span class="sifraoValores">R$</span
                    ><span class="valoresFixadosFooter">{{
                      this.converteValorParaMoeda(valorMensalidadeDiferenca)
                    }}</span>
                  </div>
                </div>
                <div>
                  <div class="tituloValores">
                    <span>Taxa administrativa</span>
                  </div>
                  <div>
                    <span class="sifraoValores">R$</span
                    ><span class="valoresFixadosFooter">{{
                      converteValorParaMoeda(
                        this.somaValorTotalValoresAvista(
                          this.produtosObrigatorios,
                          this.produtosOpcionais,
                        ),
                      )
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="footerCadastroDeDadosPg text-center pb-10 mb-5 bg-white lg:pb-0 lg:mb-0 lg:pb-5"
      >
        <vs-divider />
        <div>
          <img src="../../assets/images/logo/bp-logo.png" width="150" />
        </div>
        <div class="textFooter pb-5">
          <span>2023 - Bem Protege - Todos os direitos reservados</span>
        </div>
      </div>
    </div>

    <div v-if="retornoRegistroFinanceiro">
      <div
        class="blocoCompletoPagamentoAprovado flex flex-col"
        v-if="retornoRegistroFinanceiro.ultimoStatusGalax == 'captured'"
      >
        <!--  START HEADER PAGAMENTO APROVADO -->
        <div class="flex-grow">
          <div class="invoiceHeaderDiv pt-5 pr-5 pl-5 lg:pl-20 lg:pr-20">
            <div
              class="invoice-header flex justify-between items-center w-full"
            >
              <div>
                <img src="../../assets/images/logo/bp-logo.png" width="150" />
              </div>
              <div class="div-button">
                <div class="flex gap-2 textoAmbienteSeguro items-center">
                  <img
                    src="../../assets/images/svg/iconLock.svg"
                    alt="Ícone Cadeado."
                  />
                  <span>Ambiente Seguro</span>
                </div>
              </div>
            </div>
            <hr />
          </div>
          <!--  END HEADER PAGAMENTO APROVADO -->

          <div class="container pt-20 mb-5">
            <div class="blocoPgAprovado pt-10 lg:justify-center lg:flex">
              <div class="lg:w-1/2">
                <div class="text-center">
                  <div>
                    <img
                      src="../../assets/images/svg/iconShieldBlob.svg"
                      alt="Ícone Cadeado."
                    />
                  </div>
                  <div class="textoPagamentoAprovado pb-5 pt-2">
                    <span>Seu Pagamento foi<br />aprovado &#128522;</span>
                  </div>
                </div>
                <div class="pl-5 pr-5" @click="redirectVistoriaV2()">
                  <div
                    class="botaoIrParaVistoria p-4 mb-5 flex justify-center gap-2"
                  >
                    <span>Continuar para a Vistoria</span>
                    <img
                      src="../../assets/images/svg/iconArrowRight.svg"
                      alt="Ícone seta para a direita."
                    />
                  </div>
                </div>
                <!--  START CARD DETALHES PAGAMENTO APROVADO -->
                <div class="cardDadosPagamentos p-5 mt-5 mb-5">
                  <div class="flex justify-between">
                    <div class="textoCardBranco">
                      <span>Número da proposta</span>
                    </div>
                    <div>
                      <vs-chip color="#FFE9B0">
                        <div
                          class="flex justify-center items-center chipNumeroProposta gap-2"
                        >
                          <div>
                            <img
                              src="../../assets/images/svg/iconCopy.svg"
                              alt="ícone copy"
                              class="pt-1"
                            />
                          </div>
                          <div>
                            <span class="numeroProposta"
                              >N° {{ dadosProposta.idProposta }}</span
                            >
                          </div>
                        </div>
                      </vs-chip>
                    </div>
                  </div>
                  <div>
                    <div class="flex justify-between items-center pt-5">
                      <div>
                        <div class="textoCardBranco">
                          <span>Primeira parcela</span>
                        </div>
                        <div class="textoSubtituloCardBranco">
                          <span>Taxa administrativa</span>
                        </div>
                      </div>
                      <div>
                        <span class="simboloReal mr-1">R$</span
                        ><span class="valoresCotacao">{{
                          converteValorParaMoeda(
                            this.somaValorTotalValoresAvista(
                              this.produtosObrigatorios,
                              this.produtosOpcionais,
                            ),
                          )
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <vs-divider />
                  <div class="flex justify-between items-center">
                    <div class="textoCardBrancoPgAprovado">
                      <span>Mensalidade</span>
                    </div>
                    <div class="mensalidadeValorPgAprovado">
                      <span class="simboloRealPgAprovado mr-1">R$</span
                      ><span class="valoresCotacaoPgAprovado">{{
                        this.converteValorParaMoeda(valorMensalidadeDiferenca)
                      }}</span>
                    </div>
                  </div>
                </div>
                <!--  END CARD DETALHES PAGAMENTO APROVADO -->
              </div>
            </div>
          </div>
        </div>
        <div class="text-center footerPagamento">
          <vs-divider />
          <div>
            <img src="../../assets/images/logo/bp-logo.png" width="150" />
          </div>
          <div class="textFooter pb-5">
            <span>2023 - Bem Protege - Todos os direitos reservados</span>
          </div>
        </div>
      </div>
      <div
        v-if="retornoRegistroFinanceiro.formaPagamento == 'Pix'"
        class="blocoCompletoPagamentoAprovado flex flex-col"
      >
        <!--  START HEADER PIX SELECIONADO -->
        <div class="flex-grow">
          <div class="invoiceHeaderDiv pt-5 pr-5 pl-5 lg:pl-20 lg:pr-20">
            <div
              class="invoice-header flex justify-between items-center w-full"
            >
              <div>
                <img src="../../assets/images/logo/bp-logo.png" width="150" />
              </div>
              <div class="div-button">
                <div class="flex gap-2 textoAmbienteSeguro items-center">
                  <img
                    src="../../assets/images/svg/iconLock.svg"
                    alt="Ícone Cadeado."
                  />
                  <span>Ambiente Seguro</span>
                </div>
              </div>
            </div>
            <hr />
          </div>
          <!--  END HEADER  PIX SELECIONADO -->

          <div class="container pt-20 mb-5">
            <div class="lg:justify-center lg:flex">
              <div class="lg:w-1/2">
                <div class="pl-5 pr-5">
                  <div class="text-center pl-5 pr-5">
                    <div class="textoPagamentoAprovado p-5">
                      <span
                        >Copie e cole o código QR do pix <br />
                        no app do seu banco.</span
                      >
                    </div>
                  </div>
                  <div class="hidden pb-5 text-center lg:block">
                    <VueQr :text="retornoRegistroFinanceiro.pixQrCode" />
                  </div>
                  <div class="pb-5" @click="copiarQR()">
                    <input
                      class="inputCodigoPix w-full pr-5 pl-5 pt-4 pb-3 leading-tight focus:outline-none focus:shadow-outline"
                      id="cupom"
                      type="text"
                      :value="pixQrCode"
                      readonly
                    />
                  </div>
                  <div
                    class="botaoIrParaVistoria p-4 mb-5 flex justify-center gap-2"
                    @click="redirectVistoriaV2()"
                  >
                    <span>Continuar para a Vistoria</span>
                    <img
                      src="../../assets/images/svg/iconArrowRight.svg"
                      alt="Ícone seta para a direita."
                    />
                  </div>
                  <div>
                    <vs-button
                      text-color="#114880"
                      color="#114880"
                      type="border"
                      size="large"
                      id="botaoTrocarFormaDePagamentoPix"
                      @click="trocarFormaPagamento()"
                      >Trocar Forma de Pagamento</vs-button
                    >
                  </div>
                </div>
                <!--  START CARD DETALHES PAGAMENTO APROVADO -->
                <div class="cardDadosPagamentos p-5 mt-5 mb-5">
                  <div class="flex justify-between">
                    <div class="textoCardBranco">
                      <span>Número da proposta</span>
                    </div>
                    <div>
                      <vs-chip color="#FFE9B0">
                        <div
                          class="flex justify-center items-center chipNumeroProposta gap-2"
                        >
                          <div>
                            <img
                              src="../../assets/images/svg/iconCopy.svg"
                              alt="ícone copy"
                              class="pt-1"
                            />
                          </div>
                          <div>
                            <span class="numeroProposta"
                              >N° {{ dadosProposta.idProposta }}</span
                            >
                          </div>
                        </div>
                      </vs-chip>
                    </div>
                  </div>
                  <div>
                    <div class="flex justify-between items-center pt-5">
                      <div>
                        <div class="textoCardBranco">
                          <span>Primeira parcela</span>
                        </div>
                        <div class="textoSubtituloCardBranco">
                          <span>Taxa administrativa</span>
                        </div>
                      </div>
                      <div>
                        <span class="simboloReal mr-1">R$</span
                        ><span class="valoresCotacao">{{
                          converteValorParaMoeda(
                            this.somaValorTotalValoresAvista(
                              this.produtosObrigatorios,
                              this.produtosOpcionais,
                            ),
                          )
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <vs-divider />
                  <div class="flex justify-between items-center">
                    <div class="textoCardBrancoPgAprovado">
                      <span>Mensalidade </span>
                    </div>
                    <div class="mensalidadeValorPgAprovado">
                      <span class="simboloRealPgAprovado mr-1">R$</span
                      ><span class="valoresCotacaoPgAprovado">{{
                        this.converteValorParaMoeda(valorMensalidadeDiferenca)
                      }}</span>
                    </div>
                  </div>
                </div>
                <!--  END CARD DETALHES PAGAMENTO APROVADO -->
              </div>
            </div>
          </div>
        </div>
        <div class="text-center footerPagamento">
          <vs-divider />
          <div>
            <img src="../../assets/images/logo/bp-logo.png" width="150" />
          </div>
          <div class="textFooter pb-5">
            <span>2023 - Bem Protege - Todos os direitos reservados</span>
          </div>
        </div>
      </div>
      <div
        class="blocoCompletoPagamentoAprovado flex flex-col"
        v-if="retornoRegistroFinanceiro.formaPagamento == 'Boleto'"
      >
        <!--  START HEADER BOLETO SELECIONADO -->
        <div class="flex-grow">
          <div class="invoiceHeaderDiv pt-5 pr-5 pl-5 lg:pl-20 lg:pr-20">
            <div
              class="invoice-header flex justify-between items-center w-full"
            >
              <div>
                <img src="../../assets/images/logo/bp-logo.png" width="150" />
              </div>
              <div class="div-button">
                <div class="flex gap-2 textoAmbienteSeguro items-center">
                  <img
                    src="../../assets/images/svg/iconLock.svg"
                    alt="Ícone Cadeado."
                  />
                  <span>Ambiente Seguro</span>
                </div>
              </div>
            </div>
            <hr />
          </div>
          <!--  END HEADER  BOLETO SELECIONADO -->

          <div class="container pt-20 mt-10 mb-5">
            <div class="lg:justify-center lg:flex">
              <div class="lg:w-1/2">
                <div class="pl-5 pr-5">
                  <div
                    class="botaoDownloadBoleto p-4 mb-5 flex justify-center gap-2"
                    @click="downloadBoleto()"
                  >
                    <span>Download do Boleto</span>
                    <img
                      src="../../assets/images/svg/iconDownloadWhite.svg"
                      alt="Ícone download."
                    />
                  </div>
                  <div class="text-center pl-5 pr-5">
                    <div class="textoPagamentoAprovado p-5">
                      <span>Linha digitável do boleto</span>
                    </div>
                  </div>
                  <div class="pb-5" @click="copiarLinhaDigitavel()">
                    <input
                      class="inputCodigoPix w-full pr-5 pl-5 pt-4 pb-3 leading-tight focus:outline-none focus:shadow-outline"
                      id="cupom"
                      type="text"
                      :value="linhaDigitavelBoleto"
                      readonly
                    />
                  </div>
                  <div
                    class="botaoIrParaVistoria p-4 mb-5 flex justify-center gap-2"
                    @click="redirectVistoriaV2()"
                  >
                    <span>Continuar para a Vistoria</span>
                    <img
                      src="../../assets/images/svg/iconArrowRight.svg"
                      alt="Ícone seta para a direita."
                    />
                  </div>
                  <div>
                    <vs-button
                      text-color="#114880"
                      color="#114880"
                      type="border"
                      size="large"
                      id="botaoTrocarFormaDePagamentoPix"
                      @click="trocarFormaPagamento()"
                      >Trocar Forma de Pagamento</vs-button
                    >
                  </div>
                </div>
                <!--  START CARD DETALHES PAGAMENTO APROVADO -->
                <div class="cardDadosPagamentos p-5 mt-5 mb-5">
                  <div class="flex justify-between">
                    <div class="textoCardBranco">
                      <span>Número da proposta</span>
                    </div>
                    <div>
                      <vs-chip color="#FFE9B0">
                        <div
                          class="flex justify-center items-center chipNumeroProposta gap-2"
                        >
                          <div>
                            <img
                              src="../../assets/images/svg/iconCopy.svg"
                              alt="ícone copy"
                              class="pt-1"
                            />
                          </div>
                          <div>
                            <span class="numeroProposta"
                              >N° {{ dadosProposta.idProposta }}</span
                            >
                          </div>
                        </div>
                      </vs-chip>
                    </div>
                  </div>
                  <div>
                    <div class="flex justify-between items-center pt-5">
                      <div>
                        <div class="textoCardBranco">
                          <span>Primeira parcela</span>
                        </div>
                        <div class="textoSubtituloCardBranco">
                          <span>Taxa administrativa</span>
                        </div>
                      </div>
                      <div>
                        <span class="simboloReal mr-1">R$</span
                        ><span class="valoresCotacao">{{
                          converteValorParaMoeda(
                            this.somaValorTotalValoresAvista(
                              this.produtosObrigatorios,
                              this.produtosOpcionais,
                            ),
                          )
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <vs-divider />
                  <div class="flex justify-between items-center">
                    <div class="textoCardBrancoPgAprovado">
                      <span>Mensalidade</span>
                    </div>
                    <div class="mensalidadeValorPgAprovado">
                      <span class="simboloRealPgAprovado mr-1">R$</span
                      ><span class="valoresCotacaoPgAprovado">{{
                        this.converteValorParaMoeda(valorMensalidadeDiferenca)
                      }}</span>
                    </div>
                  </div>
                </div>
                <!--  END CARD DETALHES PAGAMENTO APROVADO -->
              </div>
            </div>
          </div>
        </div>
        <div class="text-center footerPagamento">
          <vs-divider />
          <div>
            <img src="../../assets/images/logo/bp-logo.png" width="150" />
          </div>
          <div class="textFooter pb-5">
            <span>2023 - Bem Protege - Todos os direitos reservados</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from '../../services';
import notify from './../../utils/notify';
import cpfCnpj from '../../services/cpfCnpj';
import moment from 'moment';
import VueQr from 'vue-qr';
import vSelect from 'vue-select';
import {
  getSelectsCidades,
  getSelectsEstados,
} from './../../services/ufMunicipio';
import { TIPO_PRODUTO } from '../../commons/dicionarioTipoProduto';
import { obterParticipacaoProdutoInvoice } from '../../services/cotacao';
import { decryptData } from '../../services/decryptData';

const URL_VISTORIA = 'https://vistoria.bemprotege.com.br';

export default {
  name: 'invoiceBP-3',

  components: { VueQr, vSelect },

  data() {
    return {
      beneficios: [],
      produtosOpcionais: [],
      produtosObrigatorios: [],
      tiposPessoa: [
        {
          id: 1,
          tipoPessoa: 'Pessoa Física',
        },
        {
          id: 2,
          tipoPessoa: 'Pessoa Jurídica',
        },
      ],
      arrayDuplicados: [],
      novaInvoiceBP: true,
      formularioConfirmacaoDados: false,
      verMaisBeneficiosInclusos: false,
      verProdutosOpcionais: true,
      verDadosPessoais: false,
      verDadosEndereco: false,
      verDadosFinanceiros: false,
      verDadosCartaoDeCredito: true,
      verDadosPix: false,
      verDadosFGTS: false,
      verPagamentoBoleto: false,
      rotacionaIconSetaProdutosOpcionais: false,
      rotacionaIconSetaCadastroDadosPessoais: false,
      rotacionaIconSetaDadosEndereco: false,
      rotacionaIconSetaDadosPagamento: false,
      iconCheckCadastro: false,
      iconCheckEndereco: false,
      cpfCadastro: null,
      windowWidth: null,
      windowLg: null,
      dadosProposta: null,
      cupomDesconto: null,
      dangerCupomDesconto: false,
      errosValidate: [],
      formasPagamentosGerais: null,
      formaPagamentoSelecionada: 'Cartão de Crédito',
      retornoRegistroFinanceiro: null,
      idRegistroFinanceiro: null,
      retornoAPI: null,
      pixQrCode: null,
      linhaDigitavelBoleto: null,
      valorDesconto: null,
      formDadosPessoais: {
        tipoPessoa: 'Pessoa Física',
        cpfcnpj: null,
        nome: null,
        email: null,
        celular: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        estado: null,
        unificarAssociado: false,
        idSelecionadoMescla: null,
        canaisComunicacao: ['WhatsApp', 'Email', 'SMS'],
      },
      cartaoDeCredito: {
        name: null,
        cardNumber: null,
        expiration: null,
        security: null,
      },
      listEstados: [],
      listCidade: [],
      isRecalculating: false,
      produtosRemovidos: [],
      produtosBeneficiosExibir: [],
    };
  },
  computed: {
    beneficiosProdutosExibidos() {
      if (this.verMaisBeneficiosInclusos || this.windowWidth > this.windowLg) {
        return this.produtosBeneficiosExibir;
      } else {
        return this.produtosBeneficiosExibir.slice(0, 5);
      }
    },
    valorMensalidadeDiferenca: function () {
      const _valorMensalidadeDiferenca = this.somaValorTotalOriginal(
        this.produtosObrigatorios,
        this.produtosOpcionais,
      );
      return _valorMensalidadeDiferenca;
    },
  },
  methods: {
    alternaVisualizarProdutosInclusos() {
      this.verMaisBeneficiosInclusos = !this.verMaisBeneficiosInclusos;
    },
    alternaRotacaoIconProdutosOpcionais() {
      this.rotacionaIconSetaProdutosOpcionais =
        !this.rotacionaIconSetaProdutosOpcionais;
    },
    proximaEtapaProdutosOpcionais() {
      this.alternaRotacaoIconProdutosOpcionais();

      this.verProdutosOpcionais = false;
      if (this.verProdutosOpcionais == false) {
        this.verDadosPessoais = true;
        this.verDadosEndereco = false;
        this.verDadosFinanceiros = false;
      }
    },
    alternaRotacaoIconCadastroDadosPessoais() {
      this.rotacionaIconSetaCadastroDadosPessoais =
        !this.rotacionaIconSetaCadastroDadosPessoais;
    },
    async proximaEtapaCadastroDadosPessoais() {
      this.errosValidate = [];
      let validaCelular = false;

      await this.validateFields([
        'cpfCnpjInput',
        'nomeCompletoInput',
        'emailInput',
        'celularInput',
      ]);
      this.errosValidate = this.$validator.errors.all();

      if (this.formDadosPessoais.celular) {
        validaCelular = this.verificaCelular(this.formDadosPessoais.celular);
      }
      if (this.formDadosPessoais.cpfcnpj) {
        const _cpfCnpj =
          cpfCnpj.valida_cpf_cnpj(this.formDadosPessoais.cpfcnpj) == false;
        if (_cpfCnpj) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: `Este CPF ou CNPJ não é válido`,
            color: 'danger',
          });
          return;
        }
      }

      if (this.errosValidate.length === 0 && validaCelular) {
        this.verDadosPessoais = !this.verDadosPessoais;
        if (this.verDadosPessoais == false) {
          this.verDadosEndereco = true;
          this.alternaRotacaoIconCadastroDadosPessoais();
          setTimeout(() => {
            this.iconCheckCadastro = true;
          }, '800');
        }
      }
    },
    alternaRotacaoIconDadosEndereco() {
      this.rotacionaIconSetaDadosEndereco =
        !this.rotacionaIconSetaDadosEndereco;
    },
    async proximaEtapaDadosEndereco() {
      this.errosValidate = [];
      await this.validateFields([
        'CEP',
        'Endereco',
        'numero',
        'Bairro',
        'cidade',
        'estado',
      ]);
      this.errosValidate = this.$validator.errors.all();
    },
    alternaRotacaoIconDadosPagamento() {
      this.rotacionaIconSetaDadosPagamento =
        !this.rotacionaIconSetaDadosPagamento;
    },
    alternaVisualizarDadosPagamento() {
      this.alternaRotacaoIconDadosPagamento();

      this.verDadosFinanceiros = !this.verDadosFinanceiros;
      if (this.verDadosFinanceiros) {
        this.verProdutosOpcionais = false;
        this.verDadosPessoais = false;
        this.verDadosEndereco = false;
      }
    },
    alternaVisualizarCartao() {
      this.verDadosCartaoDeCredito = !this.verDadosCartaoDeCredito;
      if (this.verDadosCartaoDeCredito) {
        this.verDadosPix = false;
        this.verDadosFGTS = false;
        this.verPagamentoBoleto = false;
      }
    },
    alternaVisualizarPix() {
      this.verDadosPix = !this.verDadosPix;
      if (this.verDadosPix) {
        this.verDadosCartaoDeCredito = false;
        this.verDadosFGTS = false;
        this.verPagamentoBoleto = false;
      }
    },
    alternaVisualizarDadosFGTS() {
      this.verDadosFGTS = !this.verDadosFGTS;
      if (this.verDadosFGTS) {
        this.verDadosPix = false;
        this.verDadosCartaoDeCredito = false;
        this.verPagamentoBoleto = false;
      }
    },
    alternaVisualizarPgBoleto() {
      this.verPagamentoBoleto = !this.verPagamentoBoleto;
      if (this.verPagamentoBoleto) {
        this.verDadosFGTS = false;
        this.verDadosPix = false;
        this.verDadosCartaoDeCredito = false;
      }
    },
    capturaValorWidthAtual() {
      this.windowWidth = window.innerWidth;
      this.windowLg = 992;
    },
    retornarAoTopo() {
      window.scrollTo({
        top: 0,
        behavior: 'auto',
      });
    },
    async buscaDados() {
      try {
        this.$vs.loading();
        const objSend = { chave: this.$route.params.chave };

        const res = await service.post('CotacaoAberta', 'buscaDados', objSend);
        if (res.data.length > 0) {
          this.dadosProposta = res.data[0];
          this.beneficios = this.dadosProposta.beneficios;

          const produtosObrigatorios = this.dadosProposta.produtos.filter(
            (produto) => produto.obrigatorio,
          );

          this.produtosBeneficiosExibir = [
            ...produtosObrigatorios,
            ...this.beneficios,
          ];

          if (this.dadosProposta) {
            this.atribuiProdutosOpcionais();
            this.atribuiProdutosObrigatorios();
          }
          await this.preencheDadosProposta();
          this.buscaFormasPagamento(this.dadosProposta.idCarteiraCobranca);
        } else {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Você não tem acesso a visualização desta Proposta.',
            color: 'danger',
          });
        }
      } catch (e) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: e,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
        this.isRecalculating = false;
      }
    },
    atribuiProdutosOpcionais() {
      this.produtosOpcionais = [];

      const jsonFacilitadorProdutos =
        this.dadosProposta.jsonFacilitadorProdutos;
      const possuiJsonFacilitadorProdutos =
        jsonFacilitadorProdutos && jsonFacilitadorProdutos !== '0';

      if (possuiJsonFacilitadorProdutos) {
        this.dadosProposta.jsonFacilitadorProdutos = JSON.parse(
          jsonFacilitadorProdutos,
        );

        this.dadosProposta.jsonFacilitadorProdutos.forEach((produto) => {
          if (!produto.obrigatorio) {
            produto.selecionado = false;
            const produtoExistente = this.dadosProposta.produtos.find(
              (findProduto) => findProduto.id_produto === produto.id_produto,
            );

            if (produtoExistente) {
              produto.selecionado = true;
            }

            const novoProduto = {
              idProduto: produto.id_produto,
              selecionado: produto.selecionado,
              nomeProduto: produto.nomeProduto,
              valor: produto.valor,
              valorFinal: produto.valorFinal,
              isMensal: produto.isMensal || produto.ismensal,
              produtosLinkados: produto.produtosLinkados,
              sobreporOutrosProdutos: produto.sobreporOutrosProdutos,
              produtoVisivel: produto.produtoVisivel,
              visivelProposta: produto.visivelProposta,
              produtosComplementares: produto.produtosComplementares,
              isComplementar: produto.isComplementar,
              exibir: true,
              id_tipoProduto: produto.id_tipoProduto,
              valorCotaParticipacao: produto.valorCotaParticipacao,
              valorParticipacaoMinimo: produto.valorParticipacaoMinimo,
            };

            this.produtosOpcionais.push(novoProduto);
          }
        });
        this.produtosOpcionais.sort(this.orndenarPorNome);
      } else {
        this.dadosProposta.produtos.forEach((produto) => {
          if (!produto.obrigatorio) {
            const novoProduto = {
              idProduto: produto.id_produto,
              selecionado: true,
              nomeProduto: produto.nomeProduto,
              descontoConcedido: produto.descontoConcedido,
              valorFinal: produto.valorFinal,
              isMensal: produto.isMensal || produto.ismensal,
              produtoVisivel: produto.produtoVisivel,
              visivelProposta: produto.visivelProposta,
              produtosComplementares: produto.produtosComplementares,
              isComplementar: produto.isComplementar,
              exibir: true,
              id_tipoProduto: produto.id_tipoProduto,
              valorCotaParticipacao: produto.valorCotaParticipacao,
              valorParticipacaoMinimo: produto.valorParticipacaoMinimo,
            };
            this.produtosOpcionais.push(novoProduto);
          }
        });
      }

      this.produtosOpcionais.forEach((prod) => {
        this.defineExibicaoProdutoOpcional(prod);
      });
    },
    atribuiProdutosObrigatorios() {
      this.produtosObrigatorios = [];
      this.dadosProposta.produtos.forEach((produto) => {
        if (produto.obrigatorio == true) {
          this.produtosObrigatorios.push({
            idProduto: produto.id_produto,
            selecionado: true,
            nomeProduto: produto.nomeProduto,
            descontoConcedido: produto.descontoConcedido,
            valor: produto.valor,
            valorFinal: produto.valorFinal,
            isMensal: produto.isMensal || produto.ismensal,
            produtoVisivel: produto.produtoVisivel,
            visivelProposta: produto.visivelProposta,
            id_tipoProduto: produto.id_tipoProduto,
            valorCotaParticipacao: produto.valorCotaParticipacao,
            valorParticipacaoMinimo: produto.valorParticipacaoMinimo,
          });
        }
      });
    },
    async aplicaDesconto() {
      try {
        this.dangerCupomDesconto = false;

        if (!this.cupomDesconto) {
          this.dangerCupomDesconto = true;
          notify.notifyFail(this.$vs, 'Informe o cupom!');
          return;
        }

        if (this.dadosProposta.cupom == this.cupomDesconto.toUpperCase()) {
          this.dangerCupomDesconto = true;
          notify.notifyFail(this.$vs, 'Este cupom já foi uitlizado!');
          return;
        }

        this.$vs.loading();

        const payload = {
          cupom: this.cupomDesconto.toUpperCase(),
          idProposta: this.dadosProposta.idProposta,
          idEmpresa: this.dadosProposta.idEmpresa,
        };

        await service.post('Campanha', 'aplicarCupom', payload);
        this.cupomDesconto = '';

        this.buscaDados();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    mascaraCupom(event) {
      const input = event.target;
      input.value = input.value.replace(new RegExp(' ', 'g'), '-');
      this.dangerCupomDesconto = false;
    },
    returnLinkWhatsCliente(nome, celular) {
      const linkRelativo = window.location.origin;
      const texto = `Olá ${nome}, tudo bem? A proposta da ${this.dadosProposta.dadosAssociacao.nome} para proteger seu veículo foi gerada, você consegue aceita-la e fazer sua vistoria tudo por lá, acesse ${linkRelativo}/proposta/${this.dadosProposta.chave}`;

      const textoEncode = encodeURI(texto);

      const link = `https://api.whatsapp.com/send?phone=55${celular}&text=${textoEncode}`;
      //else link = `whatsapp://send?phone=55${celular}&text=${textoEncode}`;

      return link;
    },
    returnLinkWhatsVendedor() {
      const linkRelativo = window.location.origin;
      const texto = `Olá ${this.dadosProposta.dadosVendedor.usuario}, tudo bem?Sua proposta para proteger seu veículo ${this.dadosProposta.dadosVeiculo.veiculoMarca} foi gerada, você consegue aceitá-la e fazer sua vistoria agora mesmo, acesse ${linkRelativo}/proposta/${this.dadosProposta.chave}`;
      const textoEncode = encodeURI(texto);

      const link = `https://api.whatsapp.com/send?phone=55${this.dadosProposta.dadosVendedor.telefone}&text=${textoEncode}`;

      return link;
    },
    copiarText() {
      let linkRelativo = window.location.origin;
      // let msg = "Linha digitável copiado para a área de Transfêrencia";
      //O texto que será copiado
      const texto = `${linkRelativo}/propostasBP/${this.dadosProposta.chave}`;
      //Cria um elemento input (pode ser um textarea)
      let inputTest = document.createElement('input');
      inputTest.value = texto;
      //Anexa o elemento ao body
      document.body.appendChild(inputTest);
      //seleciona todo o texto do elemento
      inputTest.select();
      //executa o comando copy
      //aqui é feito o ato de copiar para a area de trabalho com base na seleção
      document.execCommand('copy');
      //remove o elemento
      document.body.removeChild(inputTest);

      notify.notifySuccess(this.$vs, 'Link copiado com sucesso!');
    },
    somaValorTotalMes(arr1, arr2) {
      let total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal == true && element.excluido != true)
            total = total + element.valorFinal;
        });
      if (arr2 && arr2.length > 0)
        arr2.forEach((element) => {
          if (element.isMensal == true && element.selecionado == true)
            total = total + element.valorFinal;
        });

      return this.converteValorParaMoeda(total);
    },
    somaValorTotalValoresAvista(arr1, arr2) {
      let total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal != true) total = total + element.valorFinal;
        });
      if (arr2 && arr2.length > 0)
        arr2.forEach((element) => {
          if (element.isMensal != true && element.selecionado == true)
            total = total + element.valorFinal;
        });
      return total;
    },
    calculaDesconto(arr1, arr2) {
      let total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal != true) total = total + element.valorFinal;
        });
      if (arr2 && arr2.length > 0)
        arr2.forEach((element) => {
          if (element.isMensal != true && element.selecionado == true)
            total = total + element.valorFinal;
        });
      return total;
    },
    somaValorTotalOriginal(arr1, arr2) {
      let total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal == true && element.excluido != true)
            total = total + element.valor;
        });
      if (arr2 && arr2.length > 0)
        arr2.forEach((element) => {
          if (element.isMensal == true && element.selecionado == true)
            total = total + element.valor;
        });
      return total;
    },
    converteValorParaMoeda(valor) {
      return valor.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'decimal',
      });
    },
    queroContratarOnline() {
      this.$vs.loading();
      // Criar uma Promise manualmente
      const loadingPromise = new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 1000);
      });

      loadingPromise
        .then(() => {
          this.novaInvoiceBP = false;
          this.formularioConfirmacaoDados = true;
          this.retornarAoTopo();
        })
        .finally(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Parabéns',
            text: `Cupom ativado com sucesso!`,
            color: 'success',
          });
        });
    },
    async atulizaProdutosOpcionais(acao, objSend) {
      try {
        this.$vs.loading();

        await service.post('CotacaoAberta', acao, objSend);

        this.buscaDados();
      } catch (error) {
        this.$vs.loading.close();

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Não foi possível Atualizar opcionais`,
          color: 'danger',
        });
      }
    },
    async selecionaProduto(item, selecionado) {
      try {
        const produtosAtualizar = [];
        this.isRecalculating = true;

        if (item.sobreporOutrosProdutos) {
          //item é o objeto do produto
          const podeSobreporOutrosProdutos =
            item.sobreporOutrosProdutos.split(',');

          podeSobreporOutrosProdutos.forEach((element) => {
            //podeSobreporOutrosProdutos é o array de ids a serem sobrepostos e element é o id iterado
            this.produtosOpcionais.forEach((elementSel) => {
              if (element == elementSel.idProduto) {
                if (
                  item.selecionado == true &&
                  elementSel.selecionado == true
                ) {
                  elementSel.selecionado = false;

                  const prodSobreposto = {
                    idProposta: this.dadosProposta.idProposta,
                    acao:
                      elementSel.selecionado === false
                        ? 'remover'
                        : 'adicionar',
                    idProduto: elementSel.idProduto,
                    valorFinal: elementSel.valorFinal,
                  };

                  produtosAtualizar.push(prodSobreposto);
                }
              }
            });
          });
        }

        const idsProdutosLinkados = item.produtosLinkados.split(',');
        idsProdutosLinkados.forEach((idLink) => {
          if (idLink) {
            this.produtosOpcionais.forEach((element) => {
              if (idLink == element.idProduto) {
                element.selecionado = selecionado == false ? false : true;
                const _produto = {
                  idProposta: this.dadosProposta.idProposta,
                  acao: element.selecionado === true ? 'adicionar' : 'remover',
                  idProduto: element.idProduto,
                  valorFinal: element.valorFinal,
                };

                produtosAtualizar.push(_produto);
              }
            });
          }
        });

        if (item.sobreporOutrosProdutos) {
          let prodssobreporOutrosProdutos =
            item.sobreporOutrosProdutos.split(',');
          prodssobreporOutrosProdutos.forEach((element) => {
            this.produtosObrigatorios.forEach((elementSel, index) => {
              if (elementSel.idProduto == element) {
                if (item.selecionado == true) {
                  this.produtosRemovidos.push(elementSel);
                  elementSel.excluido = true;
                } else {
                  this.produtosRemovidos.splice(index, 1);
                  elementSel.excluido = false;
                }
              }
            });
          });
        }

        if (item.produtosComplementares) {
          const idsProdutosComplementares =
            item.produtosComplementares.split(',');
          idsProdutosComplementares.forEach((idComplemento) => {
            if (idComplemento) {
              this.produtosOpcionais.forEach((element) => {
                if (idComplemento == element.idProduto) {
                  element.exibir = true;
                  // element.selecionado = selecionado == false ? false : true;
                  // const _produto = {
                  //   idProposta: this.dadosProposta.idProposta,
                  //   acao:
                  //     element.selecionado === true ? 'adicionar' : 'remover',
                  //   idProduto: element.idProduto,
                  //   valorFinal: element.valorFinal,
                  // };
                  // produtosAtualizar.push(_produto);
                }
              });
            }
          });
        }

        const itemArray = {};
        itemArray.acao = selecionado == true ? 'adicionar' : 'remover';
        itemArray.idProduto = item.idProduto;
        itemArray.valorFinal = item.valorFinal;
        produtosAtualizar.unshift(itemArray);

        const objSend = {
          idProposta: this.dadosProposta.idProposta,
          idRegional: this.dadosProposta.idRegional,
          produtos: produtosAtualizar,
        };

        await this.atulizaProdutosOpcionais('alteraOpcional', objSend);

        if (item.id_tipoProduto === TIPO_PRODUTO.TIPO_PRODUTO_CASCO) {
          const participacao = await obterParticipacaoProdutoInvoice(
            item,
            selecionado,
          );

          const { valorCotaParticipacao, valorParticipacaoMinimo } =
            participacao;

          await service.post('CotacaoAberta', 'atualizarParticipacao', {
            idEmpresa: this.dadosProposta.idEmpresa,
            idProposta: this.dadosProposta.idProposta,
            produto: item,
            valorCotaParticipacao,
            valorParticipacaoMinimo,
            idProspect: this.dadosProposta.dadosCliente.idProspect,
          });
        }
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Não foi possível Atualizar opcionais do veículo',
        );
        this.isRecalculating = false;
      }
    },
    async preencheDadosProposta() {
      if (this.dadosProposta) {
        this.formDadosPessoais.tipoPessoa = this.dadosProposta.dadosCliente.tipo
          ? this.dadosProposta.dadosCliente.tipo
          : 'Pessoa Física';
        this.formDadosPessoais.cpfcnpj = this.dadosProposta.dadosCliente.cpf;
        this.formDadosPessoais.nome = this.dadosProposta.dadosCliente.associado;
        this.formDadosPessoais.email = this.dadosProposta.dadosCliente.email;
        this.formDadosPessoais.celular =
          this.dadosProposta.dadosCliente.celular;
        this.formDadosPessoais.cep = this.dadosProposta.dadosCliente.cep;
        this.formDadosPessoais.endereco =
          this.dadosProposta.dadosCliente.endereco;
        this.formDadosPessoais.numero = this.dadosProposta.dadosCliente.numero;
        this.formDadosPessoais.complemento =
          this.dadosProposta.dadosCliente.complemento;
        this.formDadosPessoais.bairro = this.dadosProposta.dadosCliente.bairro;
        this.formDadosPessoais.cidade = this.dadosProposta.dadosCliente.cidade;
        this.formDadosPessoais.estado = this.dadosProposta.dadosCliente.estado;

        await this.getListCidade(null, this.dadosProposta.dadosCliente.estado);
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    validateFields(fields) {
      return Promise.all(
        fields.map((field) => this.$validator.validate(field)),
      );
    },
    verificaCelular(telefone) {
      telefone = telefone.replace(/\D/g, '');
      const regexSequencial = /(\d)\1{8}/;
      if (!(telefone.length >= 10 && telefone.length <= 11)) return false;

      //Se tiver 11 caracteres, verificar se começa com 9 o celular
      if (telefone.length == 11 && parseInt(telefone.substring(2, 3)) != 9) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite um número de celular válido',
          color: 'warning',
        });
        return false;
      }

      for (let n = 0; n < 10; n++) {
        if (
          telefone == new Array(11).join(n) ||
          telefone == new Array(12).join(n)
        ) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Digite um número de celular válido',
            color: 'warning',
          });
          return false;
        }
      }
      const codigosDDD = [
        11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34,
        35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62,
        64, 63, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85,
        86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99,
      ];
      if (codigosDDD.indexOf(parseInt(telefone.substring(0, 2))) == -1) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite um número de celular válido',
          color: 'warning',
        });
        return false;
      }
      if (
        telefone.length == 10 &&
        [2, 3, 4, 5, 7].indexOf(parseInt(telefone.substring(2, 3))) == -1
      ) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite um número de celular válido',
          color: 'warning',
        });
        return false;
      }
      if (regexSequencial.test(telefone)) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite um número de celular válido',
          color: 'warning',
        });
        return false;
      }
      if (this.dadosProposta.dadosVendedor.telefone) {
        let celularConsultor = '';
        this.dadosProposta.dadosVendedor.telefone
          ? (celularConsultor =
              this.dadosProposta.dadosVendedor.telefone.replace(/\D/g, ''))
          : '';
        if (telefone == celularConsultor) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Digite um número de celular diferente do consultor.',
            color: 'danger',
          });
          return false;
        }
      }
      return true;
    },
    keyMonitorCEP: function () {
      if (this.formDadosPessoais.cep.length == 10) {
        this.$vs.loading();
        const cepbusca = this.formDadosPessoais.cep
          .replace('.', '')
          .replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then(async (res) => {
            res.data = decryptData(res.data);
            this.formDadosPessoais.endereco = res.data.street;
            this.formDadosPessoais.bairro = res.data.neighborhood;
            this.formDadosPessoais.cidade = res.data.city;
            this.formDadosPessoais.estado = res.data.state;

            await this.getListCidade(null, res.data.state);

            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não foi possível encontrar o CEP, informe o restante do endereço manualmente ou confira o CEP.',
              color: 'danger',
            });
          });
      }
    },
    keymonitorCpfCnpj: function () {
      if (this.formDadosPessoais.cpfcnpj.length == 14) {
        if (cpfCnpj.valida_cpf_cnpj(this.formDadosPessoais.cpfcnpj) == false) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: `Este CPF/CNPJ não é válido`,
            color: 'danger',
          });
          return;
        }
      }
    },
    confirmaPagamento(dados) {
      //dados é a forma de pagamento selecionada
      this.$vs.loading();
      let objSend = {};

      const tipoPagamento = this.formasPagamentosGerais.find(
        (x) =>
          x.nomePagamento == this.formaPagamentoSelecionada &&
          x.nomeProduto == 'Entrada',
      );

      const prods = [];
      //alimenta o array prods com os produtos obrigatórios a vista
      if (this.produtosObrigatorios && this.produtosObrigatorios.length > 0)
        this.produtosObrigatorios.forEach((produto) => {
          if (produto.isMensal != true) prods.push(produto);
        });
      //alimente o array prods com os produtos a vista opcionais selecionados
      if (this.produtosOpcionais && this.produtosOpcionais.length > 0)
        this.produtosOpcionais.forEach((produto) => {
          if (produto.isMensal != true && produto.selecionado == true)
            prods.push(produto);
        });

      //insere apenas os ids dos produtos no objSend.produtosVinculados e tranforma em string se houverem produtos
      if (prods.length > 0) {
        objSend.produtosVinculados = [];
        prods.forEach((produto) => {
          objSend.produtosVinculados.push(produto.idProduto);
        });
        objSend.produtosVinculados = objSend.produtosVinculados.toString();
      } else objSend.idProduto = prods[0].idProduto;

      //monta objSend
      objSend.idAssociado = this.dadosProposta.dadosCliente.idProspect;
      objSend.idProposta = this.dadosProposta.idProposta;
      objSend.idTipoPagamentoEmpresa = tipoPagamento
        ? tipoPagamento.id_tipoPagamentoEmpresa
        : null;
      objSend.idCarteira = 6; // this.dadosProposta.idCarteiraCobranca;
      objSend.idCartao = dados ? dados.idCartao : null;
      objSend.formaPagamento = this.formaPagamentoSelecionada;
      objSend.valor = this.somaValorTotalValoresAvista(
        this.produtosObrigatorios,
        this.produtosOpcionais,
      );
      objSend.isGalax = true;
      objSend.descricao =
        'Valor Entrada Proposta ' + this.dadosProposta.idProposta;
      objSend.dataVencimento = moment().format('YYYY-MM-DD');
      if (this.formaPagamentoSelecionada != 'Cartão de Crédito')
        objSend.dataVencimento = moment().add(2, 'days').format('YYYY-MM-DD');
      objSend.dataVencimentoOriginal = objSend.dataVencimento;

      service
        .post('CotacaoAberta', 'geraCobrancaEntrada', objSend)
        .then((res) => {
          this.idRegistroFinanceiro = res.data.idRegistroFinanceiro;
          if (this.idRegistroFinanceiro) {
            this.retornoRegistroFinanceiro = res.data.transacao[0];
            this.retornoAPI = JSON.parse(
              this.retornoRegistroFinanceiro.retornoAPI,
            );
            this.retornoRegistroFinanceiro.pixQrCode
              ? (this.pixQrCode = this.retornoRegistroFinanceiro.pixQrCode)
              : null;
            this.retornoRegistroFinanceiro.linhaDigitavel
              ? (this.linhaDigitavelBoleto =
                  this.retornoRegistroFinanceiro.linhaDigitavel)
              : null;
            if (res.data.galax.Charge.Transactions[0].status == 'denied') {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Negada na Operadora',
                color: 'danger',
              });
              this.retornoRegistroFinanceiro = null;
              this.$vs.loading.close();
              return;
            }
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    async adicionaCartao(dadosCartao) {
      try {
        const res = await service.post('Associado', 'AdicionarCartao', {
          ...dadosCartao,
          idProspect: this.dadosProposta.dadosCliente.idProspect,
          idEmpresa: this.dadosProposta.idEmpresa,
          idProposta: this.dadosProposta.idProposta,
        });
        if (res) {
          return res;
        }
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      }
    },
    async pagarComCartaoCredito() {
      this.errosValidate = [];
      await this.validateFields([
        'cvvCartao',
        'ExpiracaoCartao',
        'NumeroDoCartao',
        'nomeCompleto',
      ]);
      this.errosValidate = this.$validator.errors.all();

      if (this.errosValidate.length === 0) {
        this.$vs.loading();
        const cartaoAdicionado = await this.adicionaCartao(
          this.cartaoDeCredito,
        );
        let dadosCartaoAdicionado = {};
        if (cartaoAdicionado) {
          dadosCartaoAdicionado = {
            name: this.cartaoDeCredito.name,
            cardNumber: cartaoAdicionado.data.number,
            expiration: this.cartaoDeCredito.expiration,
            security: this.cartaoDeCredito.security,
            bandeira: cartaoAdicionado.data.Brand.name,
            selecionado: true,
            idCartao: cartaoAdicionado.data.myId,
          };
          this.confirmaPagamento(dadosCartaoAdicionado);
        } else {
          this.$vs.loading.close();
          return;
        }
        this.$vs.loading.close();
      }
    },
    buscaFormasPagamento(idCarteira) {
      this.$vs.loading();
      service
        .post('CotacaoAberta', 'buscaFormasPagamento', {
          idEmpresa: this.dadosProposta.idEmpresa,
          idProposta: this.dadosProposta.idProposta,
          idCarteiraCobranca: idCarteira,
          naoExibeTodas: false,
        })
        .then((res) => {
          const formas = res.data.formasPagamento;
          this.formasPagamentosGerais = formas;
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível encontrar as formas de Pagamento',
            color: 'danger',
          });
        });
    },
    async buscaRetornoRegistroFinanceiro() {
      await this.sleep(10000);

      if (!this.retornoRegistroFinanceiro) {
        this.$vs.loading();
        service
          .post('CotacaoAberta', 'buscaDadosProcessamentoRegistroFinanceiro', {
            idRegistroFinanceiro: this.idRegistroFinanceiro,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.data[0].dataProcessamento) {
              this.retornoRegistroFinanceiro = null;
              this.retornoAPI = JSON.parse(
                this.retornoRegistroFinanceiro.retornoAPI,
              );
              this.retornoRegistroFinanceiro.pixQrCode
                ? (this.pixQrCode = this.retornoRegistroFinanceiro.pixQrCode)
                : null;
              this.retornoRegistroFinanceiro.linhaDigitavel
                ? (this.linhaDigitavelBoleto =
                    this.retornoRegistroFinanceiro.linhaDigitavel)
                : null;
            } else {
              this.buscaRetornoRegistroFinanceiro();
            }
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      }
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    trocarFormaPagamento() {
      this.retornoRegistroFinanceiro = null;
      this.idRegistroFinanceiro = null;
    },
    downloadBoleto() {
      this.$router.push(
        `/Boleto/${this.retornoRegistroFinanceiro.idRegistroFinanceiro}?nn=${this.retornoRegistroFinanceiro.nossoNumero}`,
      );
    },
    async atualizaDadosPropostaAceita() {
      // Sanitize
      if (
        this.formDadosPessoais.estado &&
        this.formDadosPessoais.estado.label
      ) {
        this.formDadosPessoais.estado = this.formDadosPessoais.estado.label;
      }

      const objSend = {
        ...this.formDadosPessoais,
        idCotacao: this.dadosProposta.idProposta,
        idEmpresa: this.dadosProposta.idEmpresa,
      };
      this.$vs.loading();
      service
        .post('CotacaoAberta', 'aceiteProposta', objSend)
        .then(async (res) => {
          this.$vs.loading.close();
          if (res.data.sucess == true) {
            await this.proximaEtapaDadosEndereco();
            if (this.errosValidate.length === 0) {
              this.verDadosEndereco = !this.verDadosEndereco;
              this.alternaRotacaoIconDadosEndereco();
              if (this.verDadosEndereco == false) {
                this.verDadosFinanceiros = true;
                setTimeout(() => {
                  this.iconCheckEndereco = true;
                }, '800');
              }
            }
          }
        })
        .catch((erro) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: erro,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    selecionarItemDuplicado(item) {
      this.formDadosPessoais.idSelecionadoMescla = item.id_prospect;

      this.arrayDuplicados.forEach((element) => {
        element.selecionado = false;
      });

      item.selecionado = true;
    },
    copiarQR() {
      //O texto que será copiado
      const texto = this.retornoRegistroFinanceiro.pixQrCode;
      //Cria um elemento input (pode ser um textarea)
      let inputTest = document.createElement('input');
      inputTest.value = texto;
      //Anexa o elemento ao body
      document.body.appendChild(inputTest);
      //seleciona todo o texto do elemento
      inputTest.select();
      //executa o comando copy
      //aqui é feito o ato de copiar para a area de trabalho com base na seleção
      document.execCommand('copy');
      //remove o elemento
      document.body.removeChild(inputTest);
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: 'QR Code foi copiado para a área de Transfêrencia',
        color: 'success',
        time: 5000,
      });
    },
    copiarLinhaDigitavel() {
      //O texto que será copiado
      const texto = this.retornoRegistroFinanceiro.linhaDigitavel;
      //Cria um elemento input (pode ser um textarea)
      let inputTest = document.createElement('input');
      inputTest.value = texto;
      //Anexa o elemento ao body
      document.body.appendChild(inputTest);
      //seleciona todo o texto do elemento
      inputTest.select();
      //executa o comando copy
      //aqui é feito o ato de copiar para a area de trabalho com base na seleção
      document.execCommand('copy');
      //remove o elemento
      document.body.removeChild(inputTest);
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: 'Linha digitável foi copiada para a área de Transfêrencia',
        color: 'success',
        time: 5000,
      });
    },
    redirectVistoriaV2() {
      window.location = `${URL_VISTORIA}/${this.dadosProposta.chave}`;
    },
    scrollBloco(divDestino) {
      const element = this.$refs[divDestino];
      element.scrollIntoView({ behavior: 'smooth' });
    },
    orndenarPorNome(a, b) {
      const nomeA = a.nomeProduto.toUpperCase(); // Ignorar maiúsculas e minúsculas
      const nomeB = b.nomeProduto.toUpperCase(); // Ignorar maiúsculas e minúsculas

      if (nomeA < nomeB) {
        return -1; // nomeA vem antes de nomeB
      }
      if (nomeA > nomeB) {
        return 1; // nomeA vem depois de nomeB
      }
      return 0; // nomes são iguais
    },
    async getListCidade(id, sigla = null) {
      if (sigla) {
        id = this.listEstados.find((x) => x.label == sigla).id;
      }

      if (!id) {
        return;
      }

      try {
        this.listCidade = await getSelectsCidades(this.$vs, id);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    async clearCidade(value) {
      this.formDadosPessoais.cidade = null;

      if (value) {
        await this.getListCidade(value.id);
      }
    },

    defineExibicaoProdutoOpcional(produto) {
      //Verifica se o produto é pai de produtos complementares e não está selecionado
      if (produto.produtosComplementares && !produto.selecionado) {
        const produtosComplementares =
          produto.produtosComplementares.split(',');

        this.produtosOpcionais.forEach((prod) => {
          produtosComplementares.forEach((id) => {
            //Encontra o produto filho (complementar) e tira a exibição
            if (id == prod.idProduto.toString() && prod.exibir == true) {
              prod.exibir = false;
              prod.selecionado = false;

              //Deleta da proposta os produtos filhos
              const index = this.dadosProposta.produtos.findIndex((prod) => {
                return prod.id_produto.toString() == id;
              });

              if (index > 0) {
                this.dadosProposta.produtos.splice(index, 1);
              }
            }
          });
        });
      }
    },
    isCpfCanChange() {
      let retorno = true;
      if (
        this.dadosProposta.dadosCliente.situacao ||
        this.dadosProposta.dadosCliente.idStatus
      ) {
        retorno = false;
      }

      return retorno;
    },
  },
  async created() {
    this.listEstados = await getSelectsEstados();
    await this.buscaDados();
  },
  mounted() {
    this.capturaValorWidthAtual();
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Product+Sans&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');

// INVOICE INÍCIO
.invoiceHeaderDiv {
  background-color: #ffffff;
  width: 100vw;
  position: fixed;
  top: 0;
  z-index: 99;
}
.div-button {
  text-align: center;
}
hr {
  border: none;
  height: 1px;
  background-color: #eeeeee;
  margin-top: 0.625rem;
}
.cardAzul {
  background: #e6f3ff;
  border-radius: 0.94rem;
}
.textFooter {
  font-family: 'Roboto', sans-serif;
  color: #3e3e3e;
  font-size: 0.75rem;
  font-weight: 400;
}
@media (min-width: 992px) {
  .bgAzulSuperiorLg {
    background: #e6f3ff;
  }
}
#botaoWppConsultor {
  font-family: 'Product Sans', sans-serif;
  background-color: #158c12;
  border-radius: 1rem;
  font-weight: 700;
  font-size: 0.85rem;
  color: #ffffff;
  padding: 0.85rem 2rem 0.85rem 2rem;
  transition: background-color 0.3s;
  cursor: pointer;
  &:active,
  &:focus {
    background-color: #0f6a0b;
  }
  i {
    margin-left: 0.44rem;
    display: flex;
    text-align: center;
    align-items: center;
  }
}
.grupoCards {
  position: relative;
  padding-bottom: 30px;
}
.chipNumeroProposta {
  background-color: #ffe9b0;
  border-radius: 0.94rem;
}
.tituloPrimeiroCardAzulPasso2 {
  font-family: 'Product Sans', sans-serif;
  font-weight: 700;
  font-size: 1.3rem;
  color: #114880;
}
.subtituloCardPasso2 {
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
  font-weight: 400;
}
.tituloAzulPasso2 {
  font-family: 'Product Sans', sans-serif;
  font-weight: 700;
  font-size: 1.3rem;
  color: #114880;
}
.numeroProposta {
  font-family: 'Roboto', sans-serif;
  color: #114880;
  font-size: 0.75rem;
  font-weight: 700;
}
.cardAzulPasso2 {
  background: #e6f3ff;
  border-radius: 0.94rem;
}
.cardAzulPasso2Interno {
  background: #d3e9ff;
  border-radius: 0.94rem;
  position: absolute;
  bottom: 0;
}
.tituloCardAzulPasso2Interno {
  font-family: 'Roboto', sans-serif;
  color: #114880;
  font-weight: 400;
  font-size: 0.95rem;
}
subtituloAzulPasso2 .imgGustavoLimaCelular {
  margin-top: -25px;
  margin-right: 0px;
}
.descricaoVeiculoCardInterno {
  font-family: 'Roboto', sans-serif;
  color: #464646;
  font-size: 1rem;
  font-weight: 400;
}
.cardCinzaPasso2 {
  background: #f4f4f4;
  border-radius: 0.94rem;
  transition: transform 0.3s ease-in-out;
}
.nomeBeneficiosCardCinza {
  font-family: 'Roboto', sans-serif;
  color: #000000;
  font-weight: 500;
  font-size: 0.95rem;
}
.descricaoBeneficiosCardCinza {
  font-family: 'Roboto', sans-serif;
  color: #5c5c5c;
  font-weight: 500;
  font-size: 0.95rem;
}
.verMaisBeneficios {
  font-family: 'Roboto', sans-serif;
  color: #078fcf;
  font-weight: 700;
  font-size: 0.94rem;
  cursor: pointer;
}
.CardBranco {
  background: #ffffff;
  border-radius: 0.94rem;
  filter: drop-shadow(0px 0px 0.625rem rgba(0, 0, 0, 0.137));
}
.textoCardBranco {
  font-family: 'Roboto', sans-serif;
  color: #000000;
  font-size: 0.875rem;
  font-weight: 400;
}
.textoSubtituloCardBranco {
  font-family: 'Roboto', sans-serif;
  color: #606060;
  font-size: 0.875rem;
  font-weight: 400;
}
.simboloReal {
  font-family: 'Roboto', sans-serif;
  color: #000000;
  font-size: 0.94rem;
  font-weight: 700;
}
.valoresCotacao {
  font-family: 'Roboto', sans-serif;
  color: #000000;
  font-size: 1.25rem;
  font-weight: 700;
}
.placaVcl {
  font-family: 'Roboto', sans-serif;
  color: #000000;
  font-size: 1rem;
  font-weight: 700;
}
.cardVerde {
  background: #d7ffd7;
  border-radius: 0.94rem;
}
.botaoContratarOnline {
  font-family: 'Product Sans', sans-serif;
  border-radius: 1rem;
  font-weight: 700;
  font-size: 1.1rem;
  color: #ffffff;
  background: #158c12;
  transition: background-color 0.3s;
  cursor: pointer;
  &:active,
  &:focus {
    background-color: #0f6a0b;
  }
}
.botaoPrecisoDeAjudaConsultor {
  font-family: 'Product Sans', sans-serif;
  border-radius: 1rem;
  font-weight: 700;
  font-size: 0.875rem;
  color: #525252;
  background: #c3e1ff;
  transition: background-color 0.3s;
  cursor: pointer;
  &:active,
  &:focus {
    background-color: #b7d8fa;
  }
}
.divCupom {
  position: relative;
}
#cupom {
  background-image: url('../../assets/images/svg/iconCupom.svg');
  background-repeat: no-repeat;
  padding-left: 40px;
  text-indent: 25px;
}
#cupomButton {
  position: absolute;
  top: 13px;
  right: 16px;
}
@media (min-width: 992px) {
  .imgGustavoLimaCelularLg {
    margin-bottom: -60px;
  }
  .tituloPrimeiroCardAzulPasso2 {
    font-size: 2.5rem;
  }
  .subtituloCardPasso2 {
    font-size: 1.375rem;
  }
}
// PASSO 3
.textoAmbienteSeguro {
  font-family: 'Roboto', sans-serif;
  color: #8e8e8e;
  font-size: 0.875rem;
  font-weight: 400;
}
.cardsCinzaOpcoesBlock {
  overflow-x: auto;
}
.resumoValoresFundoAzul {
  background: #078fcf;
  border-radius: 1.1rem;
  color: #fffcfc;
}
.cardCinzaOpcoes {
  border-radius: 0.94rem;
  background: #f4f4f4;
  transition: transform 0.3s ease-in-out;
  overflow-x: auto;
}
.tituloCardCinzaOpcoes {
  font-family: 'Product Sans', sans-serif;
  color: #114880;
  font-size: 1.225rem;
  font-weight: 700;
}
.iconeSetaParaCimaTransform {
  transform: rotate(0deg);
  transition: transform 0.3s ease-in-out;
}
.iconeSetaParaBaixoTransform {
  transform: rotate(180deg);
  transition: transform 0.3s ease-in-out;
}
.subtituloCardCinzaOpcoes {
  font-family: 'Roboto', sans-serif;
  color: #4f7aa3;
  font-size: 0.95rem;
  font-weight: 400;
}
.footerAzul {
  position: fixed;
  bottom: 0;
  background: #078fcf;
  color: #fffcfc;
}
.tituloValores {
  font-size: 0.875rem;
  font-weight: 400;
  color: #f6f6f6;
}
.sifraoValores {
  font-size: 0.75rem;
  font-weight: 700;
  color: #f6f6f6;
}
.valoresFixadosFooter {
  font-size: 1.18rem;
  font-weight: 700;
  color: #f6f6f6;
}
.produtosOpcionaisNome {
  font-family: 'Roboto', sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  color: #000000;
}
.produtosOpcionaisDescricao {
  font-family: 'Roboto', sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
  color: #606060;
}
.divisorProdutosOpcionais {
  color: #303030;
}
.produtosOpcionaisSifra {
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: #000000;
}
.produtosOpcionaisValor {
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  color: #000000;
}
.botaoProximaEtapa {
  font-family: 'Product Sans', sans-serif;
  background: #114880;
  border-radius: 0.94rem;
  font-size: 1rem;
  font-weight: 700;
  color: #ffffff;
  cursor: pointer;
}
.slide-enter-active {
  animation: slide-animation 0.5s ease-in;
}

.slide-leave-active {
  animation: slide-animation 0.5s ease-out reverse;
}
@keyframes slide-animation {
  0% {
    height: auto;
    opacity: 0;
  }
  100% {
    height: auto;
    opacity: 1;
  }
}

.backGroundToggleTipoPessoaSelecionada {
  background-color: #cce5ff;
  border-radius: 8px;
  color: #078fcf;
  font-weight: 400;
  font-size: 0.75rem;
  padding: 0.625rem 1.25rem 0.44rem 0.44rem;
  width: 50%;
  transition: background-color 0.4s ease;
}
.backGroundToggleTipoPessoaNaoSelecionada {
  background-color: #e6e6e6;
  border-radius: 8px;
  color: #797979;
  font-weight: 400;
  font-size: 0.75rem;
  padding: 0.625rem 1.25rem 0.44rem 0.44rem;
  width: 50%;
  transition: background-color 0.4s ease;
}
.labelInputsInvoice {
  font-family: 'Roboto', sans-serif;
  color: #078fcf;
  font-size: 1rem;
  font-weight: 700;
  word-break: keep-all;
}
.cardDadosPagamentos {
  background: #ffffff;
  border-radius: 0.94rem;
  filter: drop-shadow(0px 0px 0.625rem rgba(0, 0, 0, 0.35));
}
.textoMensalidade {
  font-family: 'Roboto', sans-serif;
  color: #929292;
  font-size: 0.875rem;
  font-weight: 400;
}
.simboloRealPagamento {
  font-family: 'Roboto', sans-serif;
  color: #929292;
  font-size: 0.94rem;
  font-weight: 700;
}
.valoresCotacaoPagamento {
  font-family: 'Roboto', sans-serif;
  color: #929292;
  font-size: 1.25rem;
  font-weight: 700;
}
.buttonConfirmarPg {
  font-family: 'Product Sans', sans-serif;
  background-color: #158c12;
  border-radius: 1rem;
  font-weight: 700;
  font-size: 1rem;
  color: #ffffff;
  padding: 0.875rem 0.56rem;
  transition: background-color 0.3s;
  word-break: keep-all;
  cursor: pointer;
  &:active,
  &:focus {
    background-color: #0f6a0b;
  }
  i {
    margin-left: 0.44rem;
    display: flex;
    text-align: center;
    align-items: center;
  }
}
.textoFGTS {
  font-family: 'Roboto', sans-serif;
  color: #000000;
  font-size: 0.85rem;
  font-weight: 400;
}
.textoPgBoleto {
  color: #374957;
  font-size: 0.875rem;
  font-weight: 400;
}
.cadastroDeDadosPg {
  min-height: 100vh;
}
@media (min-width: 992px) {
  .cadastroDeDadosPg {
    min-height: 100vh;
  }
  .footerCadastroDeDadosPg {
    flex-shrink: 0;
  }
}
// PASSO 4
.blocoCompletoPagamentoAprovado {
  background: #ffffff;
  overflow: hidden;
  min-height: 100vh;
}
.textoPagamentoAprovado {
  font-family: 'Product Sans', sans-serif;
  color: #114880;
  font-size: 1.325rem;
  font-weight: 700;
}
.botaoIrParaVistoria {
  font-family: 'Product Sans', sans-serif;
  background: #158c12;
  border-radius: 0.94rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: #ffffff;
  cursor: pointer;
}
.mensalidadeValorPgAprovado {
  color: #929292;
}
.simboloRealPgAprovado {
  font-family: 'Roboto', sans-serif;
  font-size: 0.94rem;
  font-weight: 700;
}
.valoresCotacaoPgAprovado {
  font-family: 'Roboto', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
}
.textoCardBrancoPgAprovado {
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
}
.footerPagamento {
  margin-top: auto;
}
// PASSO 5 INICIO
.inputCodigoPix {
  background-image: url('../../assets/images/svg/iconCopyLarge.svg');
  background-repeat: no-repeat;
  background-position: 0.625rem center;
  text-indent: 25px;
  border-radius: 10px;
  border: 1px solid #eeeeee;
}
#botaoTrocarFormaDePagamentoPix {
  font-family: 'Product Sans', sans-serif;
  font-weight: 700;
  border-radius: 15px;
  font-size: 1.1rem;
  width: 100%;
}
// PASSO 6 INICIO
.botaoDownloadBoleto {
  font-family: 'Product Sans', sans-serif;
  background: #114880;
  border-radius: 0.94rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: #ffffff;
  cursor: pointer;
}
</style>

<style lang="scss">
.vs-select {
  background-color: #fff;

  .vs__dropdown-toggle {
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 0.5rem;
    font-size: 1.2rem;
    font-family: Arial, Helvetica, sans-serif;
  }

  .vs__dropdown-menu {
    max-height: 150px;
  }
}

.error-select .vs__dropdown-toggle {
  border-color: rgba(var(--vs-danger), 1) !important;
}

.error-select-text {
  color: rgba(var(--vs-danger), 1) !important;
  font-size: 0.65rem;
}
</style>
